import { Address } from '@app/domain/Address'
import { AddressDTO } from '@services/DTO/AddressDTO'
import { Answer } from '@app/domain/Answer'
import { ChargeRange } from '@app/domain/ChargeRange'
import { ChargeRangeDTO } from '@services/DTO/ChargeRangeDTO'
import { AnswerDTO } from '@services/DTO/AnswerDTO'
import { Area } from '../domain/Area'
import { AreaDTO } from './DTO/AreaDTO'
import { AreaSchedule } from '@app/domain/AreaSchedule'
import { AreaScheduleDTO } from '@services/DTO/AreaScheduleDTO'
import { BillingDetails } from '@app/domain/BillingDetails'
import { FloorPlan, FloorPlanDateRange } from '@app/domain/FloorPlan'
import { FloorPlanDateRangeDTO, FloorPlanDTO } from '@services/DTO/FloorPlanDTO'
import { BillingDetailsDTO } from '@services/DTO/BillingDetailsDTO'
import { Booking } from '@app/domain/Booking'
import { BookingAuditEntry } from '@app/domain/BookingAuditEntry'
import { BookingAuditEntryDTO } from '@services/DTO/BookingAuditEntryDTO'
import { BookingDTO } from '@services/DTO/BookingDTO'
import { BookingReason } from '@app/domain/BookingReason'
import { BookingReasonDTO } from '@services/DTO/BookingReasonDTO'
import { BookingAssignment, TableBookingOrder } from '@app/domain/BookingAssignment'
import { BookingReminder } from '@app/domain/BookingReminder'
import { BookingReminderDTO } from '@services/DTO/BookingReminderDTO'
import { BookingRequest } from '../features/reports/domain/BookingRequest'
import { BookingRequestDTO } from '../features/reports/services/DTO/BookingRequestDTO'
import { BookingSlot } from '../domain/BookingSlot'
import { BookingSlotDTO } from './DTO/BookingSlotDTO'
import { BookingSlotVelocityLimit, VenueVelocity } from '@app/domain/VenueVelocity'
import { BookingSlotVelocityLimitDTO, VenueVelocityDTO } from '@services/DTO/VenueVelocityDTO'
import { BookingSource } from '@app/domain/BookingSource'
import { BookingSourceDTO } from '@services/DTO/BookingSourceDTO'
import { BookingStatus, BookingStatusType } from '@app/domain/BookingStatus'
import { BookingStatusDTO, BookingStatusTypeDTO } from '@services/DTO/BookingStatusDTO'
import { ServiceStatus } from '@app/domain/ServiceStatus'
import { ServiceStatusDTO } from '@services/DTO/ServiceStatusDTO'
import { BookingsFeedbackReportData } from '@app/features/reports/domain/BookingsFeedbackReportData'
import {
    BookingsFeedbackReportDataDTO,
} from '@app/features/reports/services/DTO/BookingsFeedbackReportDataDTO'
import { BookingsPerHourReportData } from '@app/features/reports/domain/BookingsPerHourReportData'
import {
    BookingsPerHourReportDataDTO,
} from '@app/features/reports/services/DTO/BookingsPerHourReportDataDTO'
import {
    BookingsPerServiceReportData
} from '@app/features/reports/domain/BookingsPerServiceReportData'
import {
    BookingsPerServiceReportDataDTO,
} from '@app/features/reports/services/DTO/BookingsPerServiceReportDataDTO'
import {
    GiftVoucherActivityReportData,
    GiftVoucherActivityType,
} from '@app/features/reports/domain/GiftVoucherActivityReportData'
import {
    GiftVoucherActivityReportDataDTO,
} from '@app/features/reports/services/DTO/GiftVoucherActivityReportDataDTO'
import { BookingsReportData } from '@app/features/reports/domain/BookingsReportData'
import { BookingsReportDataDTO } from '@app/features/reports/services/DTO/BookingsReportDataDTO'
import { BookingsReportGraph } from '@app/features/reports/domain/BookingsReportGraph'
import { BookingsReportGraphDTO } from '@app/features/reports/services/DTO/BookingsReportGraphDTO'
import { CancellationsReportData } from '@app/features/reports/domain/CancellationsReportData'
import {
    CancellationsReportDataDTO,
} from '@app/features/reports/services/DTO/CancellationsReportDataDTO'
import { VoidedBooking } from '@app/features/reports/domain/VoidedBooking'
import { VoidedBookingDTO } from '@app/features/reports/services/DTO/VoidedBookingDTO'
import { Brand } from '@app/domain/Brand'
import { BrandDTO } from '@services/DTO/BrandDTO'
import { Business } from '../domain/Business'
import { BusinessDTO } from './DTO/BusinessDTO'
import { Cancellation } from '@app/domain/Cancellation'
import { CancellationCharge } from '@app/domain/CancellationCharge'
import { CancellationChargeDTO } from '@services/DTO/CancellationChargeDTO'
import { CancellationDTO } from '@services/DTO/CancellationDTO'
import { CancellationReason } from '@app/domain/CancellationReason'
import { CancellationReasonDTO } from '@services/DTO/CancellationReasonDTO'
import {
    CommunicationPreferences,
    ExternalReviewSource,
} from '@app/domain/CommunicationPreferences'
import {
    CommunicationPreferencesDTO,
    ExternalReviewSourceDTO,
} from '@services/DTO/CommunicationPreferencesDTO'
import { Contact } from '@app/domain/Contact'
import { ContactDTO } from '@services/DTO/ContactDTO'
import { Consumable, Menu, MenuCourse, MenuItem } from '@app/domain/Consumable'
import { ConsumableDTO, MenuCourseDTO, MenuDTO, MenuItemDTO } from './DTO/ConsumableDTO'
import { MenuLinkType } from '@app/domain/MenuLinkType'
import { MenuLinkTypeDTO } from './DTO/MenuLinkTypeDTO'
import { CreateUserRequest } from '@app/domain/CreateUserRequest'
import { CreateUserRequestDTO } from '@services/DTO/CreateUserRequestDTO'
import { CreateVenueRequest } from '@app/domain/CreateVenueRequest'
import { CreateVenueRequestDTO } from '@services/DTO/CreateVenueRequestDTO'
import { Customer } from '@app/domain/Customer'
import { CustomerDTO } from '@services/DTO/CustomerDTO'
import { CustomerListExportData } from '@app/features/reports/domain/CustomerListExportData'
import {
    CustomerListExportDataDTO,
} from '@app/features/reports/services/DTO/CustomerListExportDataDTO'
import { DateComponent } from '@app/domain/DateComponent'
import { DateComponentDTO } from '@services/DTO/DateComponentDTO'
import { DateTime } from 'luxon'
import { Deposit } from '@app/domain/Deposit'
import { DepositPayment } from '@app/domain/DepositPayment'
import { DepositDTO } from '@services/DTO/DepositDTO'
import { DepositPaymentDTO } from '@services/DTO/DepositPaymentDTO'
import { DepositsReportData } from '@app/features/reports/domain/DepositsReportData'
import { DepositsReportDataDTO } from '@app/features/reports/services/DTO/DepositsReportDataDTO'
import { DepositsReportGraph } from '@app/features/reports/domain/DepositsReportGraph'
import { DepositsReportGraphDTO } from '@app/features/reports/services/DTO/DepositsReportGraphDTO'
import { DiaryNote } from '@app/domain/DiaryNote'
import { DiaryNoteDTO } from '@services/DTO/DiaryNoteDTO'
import { DiaryPreferences, UTMSource } from '@app/domain/DiaryPreferences'
import { DiaryPreferencesDTO, UTMSourceDTO } from '@services/DTO/DiaryPreferencesDTO'
import {
    EmailMarketingConfiguration,
    EmailMarketingStatus,
} from '@app/domain/integration/email-marketing/EmailMarketingConfiguration'
import {
    EmailMarketingConfigurationDTO,
    EmailMarketingStatusDTO,
} from '@services/DTO/email-marketing/EmailMarketingConfigurationDTO'
import { EmailMarketingList } from '@app/domain/integration/email-marketing/EmailMarketingList'
import {
    EmailMarketingListAssociationType,
    EmailMarketingListField,
} from '@app/domain/integration/email-marketing/EmailMarketingListField'
import {
    EmailMarketingListAssociationTypeDTO,
    EmailMarketingListFieldDTO,
} from '@services/DTO/email-marketing/EmailMarketingListFieldDTO'
import { EmailMarketingListDTO } from '@services/DTO/email-marketing/EmailMarketingListDTO'
import { EmailMarketingSource } from '@app/domain/integration/email-marketing/EmailMarketingSource'
import { EmailMarketingSourceDTO } from '@services/DTO/email-marketing/EmailMarketingSourceDTO'
import { EmailMarketingTag } from '@app/domain/integration/email-marketing/EmailMarketingTag'
import { EmailMarketingTagDTO } from '@services/DTO/email-marketing/EmailMarketingTagDTO'
import {
    Event,
    EventBookingSlotLimit,
    EventException,
    EventRecurrence,
    MonthlyRepetitionType,
} from '@app/domain/VenueEvent'
import {
    EventBookingSlotLimitDTO,
    EventDTO,
    EventExceptionDTO,
    EventRecurrenceDTO,
    MonthlyRepetitionTypeDTO,
} from '@services/DTO/EventDTO'
import { Helper } from '@app/helpers/utilities/helper'
import { Injectable } from '@angular/core'
import { MoveBookingsRequestDTO } from '@services/DTO/MoveBookingsRequestDTO'
import { Organisation } from '../domain/Organisation'
import { OrganisationAuditEntry } from '@app/domain/OrganisationAuditEntry'
import { OrganisationAuditEntryDTO } from '@services/DTO/OrganisationAuditEntryDTO'
import { OrganisationDTO } from './DTO/OrganisationDTO'
import { PartySizeDuration } from '@app/domain/PartySizeDuration'
import { PartySizeDurationDTO } from '@services/DTO/PartySizeDurationDTO'
import { ApplePayWebDomain, PaymentsAccount } from '@app/domain/PaymentsAccount'
import { ApplePayWebDomainDTO, PaymentsAccountDTO } from '@services/DTO/PaymentsAccountDTO'
import { PaymentsAccountDetails, PaymentsAccountVerificationStatus } from '@app/domain/PaymentsAccountDetails'
import { PaymentsAccountDetailsDTO, PaymentsAccountVerificationStatusDTO } from '@services/DTO/PaymentAccountDetailsDTO'
import { Period } from '@app/domain/Period'
import { PeriodDTO } from '@services/DTO/PeriodDTO'
import { Question, QuestionType } from '@app/domain/Question'
import { QuestionDTO, QuestionTypeDTO } from '@services/DTO/QuestionDTO'
import { ReasonDateRangeFilter } from '@app/domain/ReasonDateRangeFilter'
import { ReasonDateRangeFilterDTO } from '@services/DTO/ReasonDateRangeFilterDTO'
import { ReasonScheduleRule } from '@app/domain/ReasonScheduleRule'
import { ReasonScheduleRuleDTO } from '@services/DTO/ReasonScheduleRuleDTO'
import { Schedule } from '@app/domain/Schedule'
import { ScheduleDTO } from '@services/DTO/ScheduleDTO'
import { ScheduleException } from '@app/domain/ScheduleException'
import { ScheduleExceptionDTO } from '@services/DTO/ScheduleExceptionDTO'
import { ScheduleRule } from '@app/domain/ScheduleRule'
import { ScheduleRuleDTO } from '@services/DTO/ScheduleRuleDTO'
import { SenderId } from '../domain/SenderId'
import { SenderIdDTO } from './DTO/SenderIdDTO'
import { Service } from '@app/domain/Service'
import { ServiceDTO } from '@services/DTO/ServiceDTO'
import { SMSUsageReportData } from '@app/features/reports/domain/SMSUsageReportData'
import { SMSUsageReportDataDTO } from '@app/features/reports/services/DTO/SMSUsageReportDataDTO'
import { Table } from '../domain/Table'
import { TableCombination } from '@app/domain/TableCombination'
import { TableCombinationDTO } from '@services/DTO/TableCombinationDTO'
import { TableDTO } from './DTO/TableDTO'
import { TableShape } from '@app/domain/TableShape'
import { TableShapeDTO } from '@services/DTO/TableShapeDTO'
import { Time } from '@app/domain/Time'
import { AccountUser, UserRole } from '@app/domain/AccountUser'
import { UserDTO, UserRoleDTO } from '@services/DTO/UserDTO'
import { UserNotificationPreferences } from '@app/domain/UserNotificationPreferences'
import { UserNotificationPreferencesDTO } from '@services/DTO/UserNotificationPreferencesDTO'
import { Venue } from '@app/domain/Venue'
import { VenueClosure } from '@app/domain/VenueClosure'
import { VenueClosureDTO } from '@services/DTO/VenueClosureDTO'
import { VenueDTO } from '@services/DTO/VenueDTO'
import { VenueRule, VenueRuleType } from '@app/domain/VenueRule'
import { VenueRuleDTO, VenueRuleTypeDTO } from '@services/DTO/VenueRuleDTO'
import { VenueSchedule } from '@app/domain/VenueSchedule'
import { VenueScheduleDTO } from '@services/DTO/VenueScheduleDTO'
import { BookingSlotVelocityLimitOverride } from '@app/domain/BookingSlotVelocityLimitOverride'
import {
    BookingSlotVelocityLimitOverrideDTO
} from '@services/DTO/BookingSlotVelocityLimitOverrideDTO'
import { WidgetConfiguration } from '@app/domain/WidgetConfiguration'
import { WidgetConfigurationDTO } from '@services/DTO/WidgetConfigurationDTO'
import { environment } from '../../environments/environment'
import DineroFactory from 'dinero.js'
import { SKUDTO } from '@services/DTO/SKUDTO'
import { ProductLibrary } from '@app/domain/ProductLibrary'
import { ProductLibraryDTO } from '@services/DTO/ProductLibraryDTO'
import { Voucher } from '@app/domain/Voucher'
import { VoucherDTO } from '@services/DTO/VoucherDTO'
import { SKU } from '@app/domain/SKU'
import { VoucherSKUValue } from '@app/domain/VoucherSKUValue'
import { VoucherSKUValueDTO } from '@services/DTO/VoucherSKUValueDTO'
import { GiftedVoucherDTO, GiftedVoucherRedemptionDTO } from '@services/DTO/GiftedVoucherDTO'
import { GiftedVoucher, GiftedVoucherRedemption } from '@app/domain/GiftedVoucher'
import { SaleDTO } from '@services/DTO/SaleDTO'
import { Sale, SalePurpose } from '@app/domain/Sale'
import { PaymentDTO } from '@services/DTO/PaymentDTO'
import { Payment } from '@app/domain/Payment'
import { DeliveryDetailsDTO } from '@services/DTO/DeliveryDetailsDTO'
import { DeliveryDetails } from '@app/domain/DeliveryDetails'
import { OrderDTO } from '@services/DTO/OrderDTO'
import { Order } from '@app/domain/Order'
import { OpeningHours, OpeningHoursDay } from '@app/domain/OpeningHours'
import { OpeningHoursDTO } from '@services/DTO/OpeningHoursDTO'
import { LineItemDTO, LineItemModifierDTO } from '@services/DTO/LineItemDTO'
import { LineItem, LineItemModifier } from '@app/domain/LineItem'
import { GiftedVoucherAuditEntryDTO } from '@app/domain/GiftedVoucherAuditEntryDTO'
import { GiftedVoucherAuditEntry } from '@app/domain/GiftedVoucherAuditEntry'
import { BaseUser } from '@app/domain/BaseUser'
import { ApiKeyView } from '@app/domain/ApiKeyView'
import { ApiKeyViewDTO } from './DTO/ApiKeyViewDTO'
import { BookingDocket, CoverMenuChoice, CoverProductSelection } from '@app/domain/BookingDocket'
import {
    BookingDocketDTO,
    CoverMenuChoiceDTO,
    CoverProductSelectionDTO
} from '@services/DTO/BookingDocketDTO'
import { Modifier, ModifierGroup } from '@app/domain/Modifier'
import { ModifierDTO, ModifierGroupDTO } from '@services/DTO/ModifierDTO'
import { POSSource } from '@app/domain/pos/POSSource'
import { POSSourceDTO } from '@services/DTO/pos/POSSourceDTO'
import { POSConfigurationDTO } from '@services/DTO/pos/POSConfigurationDTO'
import { POSConfiguration } from '@app/domain/pos/POSConfiguration'
import { POSTableMappingItemDTO } from '@services/DTO/pos/POSTableMappingItemDTO'
import { POSTableMappingItem } from '@app/domain/pos/POSTableMappingItem'
import { WaitlistEntry } from '@app/domain/WaitlistEntry'
import { WaitlistEntryAuditEntry } from '@app/domain/WaitlistEntryAuditEntry'
import { WaitlistEntryAuditEntryDTO, WaitlistEntryDTO } from '@services/DTO/WaitlistEntryDTO'

@Injectable({
    providedIn: 'root',
})
export class DTOAdapter {

    constructor() {
    }

    adaptOrganisation(organisation: Organisation): OrganisationDTO {
        const businesses = organisation.businesses.map(business => this.adaptBusiness(business))
        return new OrganisationDTO(
            organisation.id,
            organisation.subscriptionId,
            organisation.displayName,
            businesses,
            []
        )
    }

    adaptOrganisationDto(dto: OrganisationDTO): Organisation {
        const businesses = dto.businesses.map(dto => this.adaptBusinessDto(dto))
        const schedules = dto.schedules.map(dto => this.adaptScheduleDto(dto))
        return new Organisation(
            dto.id,
            dto.subscriptionId ?? null,
            dto.displayName,
            businesses,
            schedules
        )
    }

    adaptBusiness(business: Business): BusinessDTO {
        const venues = business.venues.map(venue => this.adaptVenue(venue))
        const address = this.adaptAddress(business.address)
        const paymentsAccount = business.paymentsAccount
        const paymentsAccounts = business.paymentsAccounts.map(account => this.adaptPaymentsAccount(account))
        return new BusinessDTO(
            business.id,
            business.displayName,
            business.phoneNumber,
            address,
            paymentsAccount ? this.adaptPaymentsAccount(paymentsAccount) : null,
            venues,
            paymentsAccounts,
            business.paymentsAccountAssignments
        )
    }

    adaptBusinessDto(dto: BusinessDTO): Business {
        const venues = dto.venues.map(dto => this.adaptVenueDto(dto))
        const paymentsAccounts = dto.paymentsAccounts.map(dto => this.adaptPaymentsAccountDto(dto))
        return new Business(
            dto.id,
            dto.displayName,
            dto.phoneNumber,
            this.adaptAddressDto(dto.address),
            venues,
            paymentsAccounts,
            dto.paymentsAccountAssignments
        )
    }

    adaptVenue(venue: Venue): VenueDTO {
        const areas = venue.areas.map(area => this.adaptArea(area))
        let bookingsClosedUntilDate = null
        if (venue.bookingsClosedUntilDate !== null) {
            bookingsClosedUntilDate = Helper.makeLocalISOFormattedDateString(
                venue.bookingsClosedUntilDate
            )
        }
        const reasons = venue.reasons.map(reason => this.adaptBookingReason(reason))
        const cancellationReasons = venue.cancellationReasons.map(cr => this.adaptCancellationReason(cr))
        const questions = venue.questions.map(question => this.adaptQuestion(question))
        const events = venue.events.map(event => this.adaptEvent(event))
        return new VenueDTO(
            venue.id,
            venue.displayName,
            venue.phoneNumber,
            this.adaptAddress(venue.address),
            venue.bookingInterval,
            venue.minPartySize,
            venue.minLargePartySize,
            venue.rules.map(rule => this.adaptVenueRule(rule)),
            venue.largePartyMessage,
            venue.noBookingSlotAvailableMessage,
            venue.shortPreBookingWindowMessage,
            venue.dogFriendlyNoAvailabilityMessage,
            venue.bookingsPausedNoAvailabilityMessage,
            venue.venueClosedNoAvailabilityMessage,
            venue.timeZone,
            venue.cancellationChargeRanges.map(range => new ChargeRangeDTO(
                range.minPartySize,
                range.maxPartySize,
                range.unitAmount,
                range.isPerCover,
                range.startDate,
                range.endDate,
                range.cutOffHours
            )),
            venue.depositRanges.map(range => new ChargeRangeDTO(
                range.minPartySize,
                range.maxPartySize,
                range.unitAmount,
                range.isPerCover,
                range.startDate,
                range.endDate,
                range.cutOffHours
            )),
            venue.cancellationChargeCutOffHours,
            venue.cancellationChargeAutomatically,
            this.adaptCommunicationPreferences(venue.communicationPreferences),
            venue.depositRefundCutOffDays,
            venue.depositRefundPolicy ? venue.depositRefundPolicy : null,
            this.adaptDiaryPreferences(venue.diaryPreferences),
            this.adaptVenueVelocity(venue.velocity),
            this.adaptWidgetConfiguration(venue.widgetConfiguration),
            areas,
            venue.customerCanChooseArea,
            [...venue.areaBookingOrder],
            bookingsClosedUntilDate,
            this.adaptBrand(venue.brand),
            venue.bookingPolicy,
            venue.largePartyBookingPolicy,
            venue.largePartyBookingPolicyMinimumPartySize,
            venue.enquiriesEnabled,
            venue.waitlistsEnabled,
            venue.emailValidationEnabled,
            venue.autoExtendSeatedBookingEndTimes,
            (venue.enabledServiceStatuses ?? []).map(status => this.adaptServiceStatus(status)),
            venue.voucherSoldEmailRecipients,
            venue.sendVoucherSoldMerchantEmail,
            reasons,
            cancellationReasons,
            questions,
            events,
            venue.metaPixelId,
            venue.bookingAssignment,
            venue.description,
            [...venue.promotionalImageIds],
            this.adaptOpeningHours(venue.openingHours),
            venue.privacyPolicy,
            venue.preorderMenuId
        )
    }

    adaptVenueDto(dto: VenueDTO): Venue {
        const areas = dto.areas.map(dto => this.adaptAreaDto(dto))
        const reasons = dto.reasons.map(dto => this.adaptBookingReasonDto(dto))
        const cancellationReasons = dto.cancellationReasons.map(dto => this.adaptCancellationReasonDto(dto))
        const questions = dto.questions.map(dto => this.adaptQuestionDto(dto))
        const events = dto.events.map(dto => this.adaptEventDto(dto))
        return new Venue(
            dto.id,
            dto.displayName,
            dto.phoneNumber,
            this.adaptAddressDto(dto.address),
            dto.bookingInterval,
            dto.minPartySize,
            dto.minLargePartySize,
            (dto.rules ?? []).map(rule => this.adaptVenueRuleDto(rule)),
            dto.largePartyMessage,
            dto.noBookingSlotAvailableMessage,
            dto.shortPreBookingWindowMessage,
            dto.dogFriendlyNoAvailabilityMessage,
            dto.bookingsPausedNoAvailabilityMessage,
            dto.venueClosedNoAvailabilityMessage,
            dto.timeZone,
            dto.cancellationChargeRanges.map(dto => new ChargeRange(
                dto.minPartySize,
                dto.maxPartySize,
                dto.unitAmount,
                dto.isPerCover,
                dto.startDate,
                dto.endDate,
                dto.cutOffHours
            )),
            dto.depositChargeRanges.map(dto => new ChargeRange(
                dto.minPartySize,
                dto.maxPartySize,
                dto.unitAmount,
                dto.isPerCover,
                dto.startDate,
                dto.endDate,
                dto.cutOffHours
            )),
            dto.cancellationChargeCutOffHours,
            dto.cancellationChargeAutomatically,
            this.adaptCommunicationPreferencesDto(dto.communicationPreferences),
            dto.depositRefundCutOffDays,
            dto.depositRefundPolicy ? dto.depositRefundPolicy : null,
            this.adaptDiaryPreferencesDto(dto.diaryPreferences),
            this.adaptVenueVelocityDto(dto.velocity),
            this.adaptWidgetConfigurationDto(dto.widgetConfiguration),
            areas,
            dto.customerCanChooseArea ?? (dto.areaBookingOrder.length === 0),
            [...dto.areaBookingOrder],
            dto.manualAcceptanceUntilDate ? new Date(dto.manualAcceptanceUntilDate) : null,
            this.adaptBrandDto(dto.brand),
            dto.bookingPolicy,
            dto.largePartyBookingPolicy ?? null,
            dto.largePartyBookingPolicyMinimumPartySize ?? null,
            dto.enquiriesEnabled,
            dto.waitlistsEnabled,
            dto.emailValidationEnabled,
            dto.autoExtendSeatedBookingEndTimes,
            (dto.enabledServiceStatuses ?? []).map(status => this.adaptServiceStatusDto(status)),
            dto.voucherSoldEmailRecipients,
            dto.sendVoucherSoldMerchantEmail ?? true,
            reasons,
            cancellationReasons,
            questions,
            events,
            dto.metaPixelId ?? null,
            new BookingAssignment(
                (dto.bookingAssignment?.tableOrders ?? []).map(order => new TableBookingOrder(
                    order.partySize,
                    [...(order.bookableIds ?? [])]
                ))
            ),
            dto.description ?? null,
            [...(dto.promotionalImageIds ?? [])],
            this.adaptOpeningHoursDto(dto.openingHours),
            dto.privacyPolicy ?? null,
            dto.preorderMenuId ?? null
        )
    }

    adaptOpeningHours(openingHours: OpeningHours | null): OpeningHoursDTO | null {
        if (openingHours === null) {
            return null
        }
        return {
            days: openingHours.days.map(day => ({
                dayOfWeek: day.dayOfWeek,
                periods: day.periods.map(period => this.adaptPeriod(period)),
            })),
        }
    }

    adaptOpeningHoursDto(dto: OpeningHoursDTO | null | undefined): OpeningHours | null {
        if (dto === null || dto === undefined) {
            return null
        }
        return new OpeningHours(
            dto.days.map(day => new OpeningHoursDay(
                day.dayOfWeek,
                day.periods.map(period => this.adaptPeriodDto(period))
            ))
        )
    }

    adaptVenueRule(rule: VenueRule): VenueRuleDTO {
        return new VenueRuleDTO(
            rule.id,
            rule.type as unknown as VenueRuleTypeDTO,
            [...rule.daysOfWeek],
            { ...rule.values }
        )
    }

    adaptVenueRuleDto(dto: VenueRuleDTO): VenueRule {
        return new VenueRule(
            dto.id,
            dto.type as unknown as VenueRuleType,
            [...dto.daysOfWeek],
            { ...dto.values }
        )
    }

    adaptCommunicationPreferences(pref: CommunicationPreferences): CommunicationPreferencesDTO {
        return new CommunicationPreferencesDTO(
            pref.sendReminderHours,
            pref.sendFeedbackRequest,
            pref.sendFeedbackRequestMinutes,
            this.adaptExternalReviewSource(pref.externalReviewSource),
            pref.externalReviewUrl,
            pref.externalReviewCount,
            pref.externalReviewDescription,
            pref.emailAddresses,
            pref.replyToEmailAddress,
            pref.feedbackEmailRecipients,
            pref.upcomingEmailRecipients,
            pref.sendRequestEmail,
            pref.sendConfirmationEmail,
            pref.sendWaitlistJoinedMerchantEmail,
            pref.sendCancellationEmail,
            pref.sendModificationEmail,
            pref.sendNoShowEmail,
            pref.sendEmailPerReviewCount,
            pref.sendFeedbackDailySummaryEmail,
            pref.sendUpcomingEmail,
            pref.sendNotificationWithNoteOnly,
            pref.sendNotificationMinimumPartySizeOnly,
            pref.diningInformation,
            pref.messagesEnabled,
            pref.messageNotificationEmail,
            pref.sendCustomerCommunicationViaSMS,
            pref.sendNotificationVIPOnly,
            pref.cancellationEmailWording,
            pref.noShowEmailWording,
            pref.preOrderMenuEmailWording,
        )
    }

    adaptDiaryPreferences(pref: DiaryPreferences): DiaryPreferencesDTO {
        return new DiaryPreferencesDTO(
            pref.confirmAddBooking,
            pref.merchantBookingsRequireChargeByDefault,
            pref.merchantRequiresCancellationReason,
            pref.pendingPaymentExpiryMinutes,
            pref.utmSources.map(utmSource => this.adaptUtmSource(utmSource)),
            pref.switchToSMS,
            pref.requireUserPinCode,
            pref.hideClosedBookingSlots,
            pref.customerFirstNameRequired,
            pref.customerLastNameRequired,
            pref.customerEmailAddressRequired,
            pref.customerPhoneNumberRequired,
        )
    }

    adaptUtmSource(utmSource: UTMSource): UTMSourceDTO {
        return new UTMSourceDTO(
            utmSource.source,
            utmSource.colour
        )
    }

    adaptExternalReviewSource(source: ExternalReviewSource | null): ExternalReviewSourceDTO | null {
        if (source === null) {
            return null
        }
        switch (source) {
            case ExternalReviewSource.Google:
                return ExternalReviewSourceDTO.Google
            case ExternalReviewSource.TripAdvisor:
                return ExternalReviewSourceDTO.TripAdvisor
        }
    }

    adaptCommunicationPreferencesDto(dto: CommunicationPreferencesDTO): CommunicationPreferences {
        return new CommunicationPreferences(
            dto.sendReminderHours,
            dto.sendFeedbackRequest,
            dto.sendFeedbackRequestMinutes,
            this.adaptExternalReviewSourceDto(dto.externalReviewSource),
            dto.externalReviewUrl,
            dto.externalReviewCount,
            dto.externalReviewDescription,
            dto.emailAddresses,
            dto.replyToEmailAddress,
            dto.feedbackEmailRecipients,
            dto.upcomingEmailRecipients,
            dto.sendRequestEmail,
            dto.sendConfirmationEmail,
            dto.sendWaitlistJoinedMerchantEmail ?? false,
            dto.sendCancellationEmail,
            dto.sendModificationEmail,
            dto.sendNoShowEmail,
            dto.sendEmailPerReviewCount,
            dto.sendFeedbackDailySummaryEmail,
            dto.sendUpcomingEmail,
            dto.sendNotificationWithNoteOnly,
            dto.sendNotificationMinimumPartySizeOnly,
            dto.diningInformation,
            dto.messagesEnabled,
            dto.messageNotificationEmail,
            dto.sendCustomerCommunicationViaSMS,
            dto.sendNotificationVIPOnly,
            dto.cancellationEmailWording ?? null,
            dto.noShowEmailWording ?? null,
            dto.preOrderMenuEmailWording ?? null,
        )
    }

    adaptDiaryPreferencesDto(dto: DiaryPreferencesDTO): DiaryPreferences {
        return new DiaryPreferences(
            dto.confirmAddBooking,
            dto.merchantBookingsRequireChargeByDefault,
            dto.merchantRequiresCancellationReason ?? null,
            dto.pendingPaymentExpiryMinutes,
            dto.utmSources.map(utmSourceDto => this.adaptUtmSourceDto(utmSourceDto)),
            dto.switchToSMS,
            dto.requireUserPinCode,
            dto.hideClosedBookingSlots,
            dto.customerFirstNameRequired ?? false,
            dto.customerLastNameRequired ?? false,
            dto.customerEmailAddressRequired ?? false,
            dto.customerPhoneNumberRequired ?? false,
        )
    }

    adaptUtmSourceDto(dto: UTMSourceDTO): UTMSource {
        return new UTMSource(
            dto.source,
            dto.colour
        )
    }

    adaptExternalReviewSourceDto(source: ExternalReviewSourceDTO | null):
        ExternalReviewSource | null {
        if (source === null) {
            return null
        }
        switch (source) {
            case ExternalReviewSourceDTO.Google:
                return ExternalReviewSource.Google
            case ExternalReviewSourceDTO.TripAdvisor:
                return ExternalReviewSource.TripAdvisor
        }
    }

    adaptVenueVelocity(velocity: VenueVelocity): VenueVelocityDTO {
        const bookingSlotBookingLimits = velocity.bookingSlotBookingLimits.map(limit => {
            return this.adaptBookingSlotVelocityLimit(limit)
        })
        const bookingSlotCoverLimits = velocity.bookingSlotCoverLimits.map(limit => {
            return this.adaptBookingSlotVelocityLimit(limit)
        })
        const dogFriendlyAllowedTimes = velocity.dogFriendlyAllowedTimes?.map(period => {
            return [
                period.start.toString(),
                period.end.toString(),
            ]
        }) ?? null
        return new VenueVelocityDTO(
            velocity.bookingLimit,
            velocity.coverLimit,
            velocity.dogFriendlyBookingLimit,
            velocity.pramAccessibleBookingLimit,
            velocity.highchairFriendlyBookingLimit,
            dogFriendlyAllowedTimes,
            bookingSlotBookingLimits,
            bookingSlotCoverLimits
        )
    }

    adaptVenueVelocityDto(dto: VenueVelocityDTO): VenueVelocity {
        const bookingSlotBookingLimits = dto.bookingSlotBookingLimits.map(dto => {
            return this.adaptBookingSlotVelocityLimitDto(dto)
        })
        const bookingSlotCoverLimits = dto.bookingSlotCoverLimits.map(dto => {
            return this.adaptBookingSlotVelocityLimitDto(dto)
        })
        const dogFriendlyAllowedTimes = dto.dogFriendlyAllowedTimes?.map((pair: string[]) => {
            return new Period(
                new Time(pair[ 0 ], null, null),
                new Time(pair[ 1 ], null, null),
                true
            )
        }) ?? null
        return new VenueVelocity(
            dto.bookingLimit,
            dto.coverLimit,
            dto.dogFriendlyBookingLimit,
            dto.pramAccessibleBookingLimit,
            dto.highchairFriendlyBookingLimit,
            dogFriendlyAllowedTimes,
            bookingSlotBookingLimits,
            bookingSlotCoverLimits
        )
    }

    adaptBookingSlotVelocityLimit(limit: BookingSlotVelocityLimit): BookingSlotVelocityLimitDTO {
        return new BookingSlotVelocityLimitDTO(
            limit.dayOfWeek,
            limit.time.toString(),
            limit.limit
        )
    }

    adaptBookingSlotVelocityLimitDto(dto: BookingSlotVelocityLimitDTO): BookingSlotVelocityLimit {
        return new BookingSlotVelocityLimit(
            dto.dayOfWeek,
            new Time(dto.time, null, null),
            dto.limit
        )
    }

    adaptWidgetConfiguration(widgetConfiguration: WidgetConfiguration): WidgetConfigurationDTO {
        return new WidgetConfigurationDTO(
            widgetConfiguration.phoneNumberRequired,
            widgetConfiguration.reserveWithGoogleEnabled,
            widgetConfiguration.reserveWithGoogleReasonId ?? null,
            widgetConfiguration.reserveWithGoogleImportantNote ?? null,
            widgetConfiguration.reserveWithGoogleAvailabilityDays,
            widgetConfiguration.primaryColour,
            widgetConfiguration.pinnedEventId ?? null,
            widgetConfiguration.dogFriendlyQuestionEnabled,
            widgetConfiguration.wheelchairAccessibleQuestionEnabled,
            widgetConfiguration.pramAccessibleQuestionEnabled,
            widgetConfiguration.highchairFriendlyQuestionEnabled
        )
    }

    adaptWidgetConfigurationDto(dto: WidgetConfigurationDTO): WidgetConfiguration {
        return new WidgetConfiguration(
            dto.phoneNumberRequired,
            dto.reserveWithGoogleEnabled,
            dto.reserveWithGoogleReasonId ?? null,
            dto.reserveWithGoogleImportantNote ?? null,
            dto.reserveWithGoogleAvailabilityDays,
            dto.primaryColour,
            dto.pinnedEventId ?? null,
            dto.dogFriendlyQuestionEnabled,
            dto.wheelchairAccessibleQuestionEnabled,
            dto.pramAccessibleQuestionEnabled,
            dto.highchairFriendlyQuestionEnabled
        )
    }

    adaptBrand(brand: Brand): BrandDTO {
        return new BrandDTO(
            brand.brandColour,
            brand.bannerImageId,
            brand.voucherLogoImageId,
            brand.facebookUrl,
            brand.instagramUrl,
            brand.twitterUrl,
            brand.websiteUrl,
            brand.linkedinUrl,
            brand.tiktokUrl,
            brand.discordUrl
        )
    }

    adaptBrandDto(dto: BrandDTO): Brand {
        return new Brand(
            dto.brandColour,
            dto.bannerImageId,
            dto.voucherLogoImageId,
            dto.facebookUrl,
            dto.instagramUrl,
            dto.twitterUrl,
            dto.websiteUrl,
            dto.linkedinUrl,
            dto.tiktokUrl,
            dto.discordUrl
        )
    }

    adaptQuestion(question: Question): QuestionDTO {
        return new QuestionDTO(
            question.id,
            question.text,
            question.required,
            this.adaptQuestionType(question.type),
            [...question.options],
            [...question.reasonIds],
            question.active
        )
    }

    adaptQuestionDto(dto: QuestionDTO): Question {
        return new Question(
            dto.id,
            dto.text,
            dto.required,
            this.adaptQuestionTypeDto(dto.type),
            [...dto.options],
            [...dto.reasonIds],
            dto.active ?? true
        )
    }

    adaptQuestionType(questionType: QuestionType): QuestionTypeDTO {
        switch (questionType) {
            case QuestionType.Checkbox:
                return QuestionTypeDTO.Checkbox
            case QuestionType.Dropdown:
                return QuestionTypeDTO.Dropdown
            case QuestionType.AcknowledgeEndTime:
                return QuestionTypeDTO.AcknowledgeEndTime
            case QuestionType.DOB:
                return QuestionTypeDTO.DOB
            case QuestionType.ReasonsForVisit:
                return QuestionTypeDTO.ReasonsForVisit
            case QuestionType.DietaryRestrictions:
                return QuestionTypeDTO.DietaryRestrictions
            case QuestionType.Text:
                return QuestionTypeDTO.Text
            case QuestionType.DietaryRestrictionsText:
                return QuestionTypeDTO.DietaryRestrictionsText
        }
    }

    adaptQuestionTypeDto(dto: QuestionTypeDTO): QuestionType {
        switch (dto) {
            case QuestionTypeDTO.Checkbox:
                return QuestionType.Checkbox
            case QuestionTypeDTO.Dropdown:
                return QuestionType.Dropdown
            case QuestionTypeDTO.AcknowledgeEndTime:
                return QuestionType.AcknowledgeEndTime
            case QuestionTypeDTO.DOB:
                return QuestionType.DOB
            case QuestionTypeDTO.ReasonsForVisit:
                return QuestionType.ReasonsForVisit
            case QuestionTypeDTO.DietaryRestrictions:
                return QuestionType.DietaryRestrictions
            case QuestionTypeDTO.Text:
                return QuestionType.Text
            case QuestionTypeDTO.DietaryRestrictionsText:
                return QuestionType.DietaryRestrictionsText
        }
    }

    adaptAnswer(answer: Answer): AnswerDTO {
        return new AnswerDTO(
            answer.question.id,
            answer.question.text,
            answer.question.required,
            this.adaptQuestionType(answer.question.type),
            answer.answer
        )
    }

    adaptAnswerDto(dto: AnswerDTO): Answer {
        const question = new Question(
            dto.questionId,
            dto.question,
            dto.required,
            this.adaptQuestionTypeDto(dto.type),
            [],
            []
        )
        return new Answer(
            question,
            dto.answer
        )
    }

    adaptEvent(event: Event): EventDTO {
        const recurrence = this.adaptEventRecurrence(event.recurrence)
        return new EventDTO(
            event.id,
            event.displayName,
            event.displayOrder,
            event.description,
            event.bookingDurations.map(duration => this.adaptPartySizeDuration(duration)),
            event.imageId,
            event.cancellationChargeAmount,
            event.cancellationChargePartyAmount,
            event.cancellationChargeCutOffHours,
            event.depositAmount,
            event.depositFlatFeeAmount,
            event.depositTableCapacityAmount,
            event.depositRefundCutOffDays,
            event.diningInformation,
            event.isExclusive,
            event.notReservableOnline,
            event.notReservableOnlineMessage,
            event.forceSendMerchantEmail,
            event.contributesToKitchenVelocity,
            event.preBookingWindowMinutes,
            event.preBookingModificationWindowMinutes,
            recurrence,
            [...event.tableIds],
            [...event.questionIds],
            event.partySizeRestriction ? [...event.partySizeRestriction] : null,
            event.dailyBookingLimit,
            event.dailyCoverLimit,
            event.partySizeRestrictedMessage,
            event.merchantNotificationEmailAddress,
            event.manualAcceptance,
            event.dogFriendlyNotAllowed,
            event.showInReserveWithGoogle,
            event.treatNonReservableTablesAsReservable,
            event.minLargePartySize,
            event.bookingSlotBookingLimits.map(limit => this.adaptEventBookingSlotLimit(limit))
        )
    }

    adaptEventDto(dto: EventDTO): Event {
        const recurrence = this.adaptEventRecurrenceDto(dto.recurrence)
        return new Event(
            dto.id,
            dto.displayName,
            dto.displayOrder,
            dto.description,
            dto.bookingDurations.map(dto => this.adaptPartySizeDurationDto(dto)),
            dto.imageId,
            dto.cancellationChargeAmount,
            dto.cancellationChargePartyAmount,
            dto.cancellationChargeCutOffHours,
            dto.depositAmount,
            dto.depositFlatFeeAmount,
            dto.depositTableCapacityAmount,
            dto.depositRefundCutOffDays,
            dto.diningInformation,
            dto.isExclusive,
            dto.notReservableOnline,
            dto.notReservableOnlineMessage,
            dto.forceSendMerchantEmail,
            dto.contributesToKitchenVelocity,
            dto.preBookingWindowMinutes,
            dto.preBookingModificationWindowMinutes,
            recurrence,
            [...dto.tableIds],
            [...dto.questionIds],
            dto.partySizeRestriction ? [...dto.partySizeRestriction] : null,
            dto.dailyBookingLimit,
            dto.dailyCoverLimit,
            dto.partySizeRestrictedMessage,
            dto.merchantNotificationEmailAddress,
            dto.manualAcceptance,
            dto.dogFriendlyNotAllowed,
            dto.showInReserveWithGoogle,
            dto.treatNonReservableTablesAsReservable,
            dto.minLargePartySize,
            dto.bookingSlotBookingLimits.map(dto => this.adaptEventBookingSlotLimitDto(dto))
        )
    }

    adaptEventRecurrence(recurrence: EventRecurrence): EventRecurrenceDTO {
        const exceptions = recurrence.exceptions.map(exception => {
            return this.adaptEventException(exception)
        })
        return new EventRecurrenceDTO(
            recurrence.startDates.map(date => this.adaptToLocalDate(date)),
            recurrence.dateComponent,
            recurrence.weeklyRepeatsOnDaysOfWeek,
            recurrence.monthlyRepetitionType !== null
                ? this.adaptMonthlyRepetitionType(recurrence.monthlyRepetitionType)
                : null,
            exceptions,
            recurrence.endDate
                ? this.adaptToLocalDate(recurrence.endDate)
                : null,
            recurrence.startTime?.toString() ?? null,
            recurrence.endTime?.toString() ?? null
        )
    }

    adaptEventRecurrenceDto(dto: EventRecurrenceDTO): EventRecurrence {
        const exceptions = dto.exceptions.map(dto => {
            return this.adaptEventExceptionDto(dto)
        })
        return new EventRecurrence(
            dto.startDates.map(date => DateTime.fromISO(date, {zone: environment.assumedVenueTimeZone}).toJSDate()),
            dto.dateComponent,
            dto.weeklyRepeatsOnDaysOfWeek,
            dto.monthlyRepetitionType !== null
                ? this.adaptMonthlyRepetitionTypeDto(dto.monthlyRepetitionType)
                : null,
            exceptions,
            dto.endDate
                ? new Date(dto.endDate)
                : null,
            dto.startTime ? new Time(dto.startTime, null, null) : null,
            dto.endTime ? new Time(dto.endTime, null, null) : null
        )
    }

    adaptEventException(exception: EventException): EventExceptionDTO {
        return new EventExceptionDTO(
            exception.id,
            this.adaptToLocalDate(exception.date)
        )
    }

    adaptEventExceptionDto(dto: EventExceptionDTO): EventException {
        return new EventException(
            dto.id,
            new Date(dto.date)
        )
    }

    adaptMonthlyRepetitionType(
        monthlyRepetitionType: MonthlyRepetitionType
    ): MonthlyRepetitionTypeDTO {
        switch (monthlyRepetitionType) {
            case MonthlyRepetitionType.DayOfMonth:
                return MonthlyRepetitionTypeDTO.DAY_OF_MONTH
            case MonthlyRepetitionType.DayOfWeek:
                return MonthlyRepetitionTypeDTO.DAY_OF_WEEK
        }
    }

    adaptMonthlyRepetitionTypeDto(dto: MonthlyRepetitionTypeDTO): MonthlyRepetitionType {
        switch (dto) {
            case MonthlyRepetitionTypeDTO.DAY_OF_MONTH:
                return MonthlyRepetitionType.DayOfMonth
            case MonthlyRepetitionTypeDTO.DAY_OF_WEEK:
                return MonthlyRepetitionType.DayOfWeek
        }
    }

    adaptArea(area: Area): AreaDTO {
        const automaticAcceptSchedule = area.automaticAcceptSchedule
            .map(dateComponent => this.adaptDateComponent(dateComponent))
        const tables = area.tables.map(area => this.adaptTable(area))
        const combinations = area.combinations.map(combination => {
            return this.adaptTableCombination(combination)
        })
        const floorPlans = area.floorPlans.map(fp => this.adaptFloorPlan(fp))
        return new AreaDTO(
            area.id,
            area.displayName,
            area.description,
            area.tableTurnaroundInterval,
            automaticAcceptSchedule,
            area.automaticAcceptPartySize,
            area.displayOrder,
            area.isActive,
            area.shouldDeclareIfNotChosen,
            tables,
            combinations,
            [...area.scheduleIds],
            floorPlans,
            area.dateCreated,
            area.dateUpdated,
            area.tableTurnaroundIntervals.map(interval => {
                return this.adaptPartySizeDuration(interval)
            }),
        )
    }

    adaptAreaDto(dto: AreaDTO): Area {
        const automaticAcceptSchedule = dto.automaticAcceptSchedule
            .map(dto => this.adaptDateComponentDto(dto))
        const tables = dto.tables.map(dto => this.adaptTableDto(dto))
        const combinations = dto.combinations.map(dto => this.adaptTableCombinationDto(dto))
        const floorPlans = (dto.floorPlans ?? []).map(dto => this.adaptFloorPlanDto(dto))
        return new Area(
            dto.id,
            dto.displayName,
            dto.description,
            dto.tableTurnaroundInterval,
            automaticAcceptSchedule,
            dto.automaticAcceptPartySize,
            dto.displayOrder,
            dto.isActive,
            dto.shouldDeclareIfNotChosen,
            tables,
            combinations,
            [...dto.scheduleIds],
            floorPlans,
            dto.dateCreated,
            dto.dateUpdated,
            (dto.tableTurnaroundIntervals ?? []).map(interval => {
                return this.adaptPartySizeDurationDto(interval)
            })
        )
    }

    adaptFloorPlan(floorPlan: FloorPlan): FloorPlanDTO {
        return new FloorPlanDTO(
            floorPlan.id,
            floorPlan.displayName,
            floorPlan.dateRanges.map(dr => this.adaptFloorPlanDateRange(dr)),
            [...floorPlan.tableIds],
            floorPlan.dateCreated.toISOString(),
            floorPlan.dateUpdated.toISOString()
        )
    }

    adaptFloorPlanDto(dto: FloorPlanDTO): FloorPlan {
        return new FloorPlan(
            dto.id,
            dto.displayName,
            dto.dateRanges.map(dr => this.adaptFloorPlanDateRangeDto(dr)),
            [...dto.tableIds],
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated)
        )
    }

    adaptFloorPlanDateRange(dateRange: FloorPlanDateRange): FloorPlanDateRangeDTO {
        return {
            startDate: this.adaptToLocalDate(dateRange.startDate),
            endDate: this.adaptToLocalDate(dateRange.endDate),
        }
    }

    adaptFloorPlanDateRangeDto(dto: FloorPlanDateRangeDTO): FloorPlanDateRange {
        return {
            startDate: this.adaptFromLocalDate(dto.startDate),
            endDate: this.adaptFromLocalDate(dto.endDate),
        }
    }

    /**
     * Convert a local date string (YYYY-MM-DD) to a Date object at local midnight.
     * This ensures the date is interpreted in the local timezone, not UTC.
     */
    private adaptFromLocalDate(dateString: string): Date {
        return DateTime.fromISO(dateString, {zone: environment.assumedVenueTimeZone})
            .toJSDate()
    }

    adaptTableCombination(combination: TableCombination): TableCombinationDTO {
        return new TableCombinationDTO(
            combination.id,
            combination.tableIds,
            combination.minimumSeats,
            combination.maximumSeats,
            combination.bookingOrder,
            combination.independentReservable
        )
    }

    adaptTableCombinationDto(dto: TableCombinationDTO): TableCombination {
        return new TableCombination(
            dto.id,
            dto.tableIds,
            dto.minimumSeats,
            dto.maximumSeats,
            dto.bookingOrder,
            dto.independentReservable
        )
    }

    adaptPartySizeDuration(partySizeDuration: PartySizeDuration): PartySizeDurationDTO {
        return new PartySizeDurationDTO(
            partySizeDuration.partySize,
            partySizeDuration.duration
        )
    }

    adaptPartySizeDurationDto(dto: PartySizeDurationDTO): PartySizeDuration {
        return new PartySizeDuration(
            dto.partySize,
            dto.duration
        )
    }

    adaptCreateVenueRequest(request: CreateVenueRequest): CreateVenueRequestDTO {
        return new CreateVenueRequestDTO(
            request.id,
            request.displayName,
            request.phoneNumber,
            this.adaptAddress(request.address),
            request.maxPartySize,
            request.timeZone,
            request.areaId,
            request.areaDisplayName,
            request.defaultBookingDuration,
            request.bookingInterval,
            request.tableTurnaroundInterval,
            request.scheduleId
        )
    }

    adaptTable(table: Table): TableDTO {
        return new TableDTO(
            table.id,
            table.displayName,
            table.reservable,
            table.minimumSeats,
            table.maximumSeats,
            table.bookingOrder,
            table.displayOrder,
            table.floorCoordinates.x,
            table.floorCoordinates.y,
            table.dimensions.width,
            table.dimensions.height,
            [...table.reasonIds],
            table.wheelchairAccessible,
            table.dogFriendly,
            table.pramAccessible,
            table.highchairFriendly,
            this.adaptTableShape(table.shape),
            table.dateCreated.toISOString(),
            table.dateUpdated.toISOString()
        )
    }

    adaptTableDto(dto: TableDTO): Table {
        return new Table(
            dto.id,
            dto.displayName,
            dto.reservable,
            dto.minimumSeats,
            dto.maximumSeats,
            dto.bookingOrder,
            dto.displayOrder,
            {
                x: dto.floorPlanX,
                y: dto.floorPlanY,
            },
            {
                width: dto.floorPlanWidth,
                height: dto.floorPlanHeight,
            },
            [...dto.reasonIds],
            dto.wheelchairAccessible,
            dto.dogFriendly,
            dto.pramAccessible,
            dto.highchairFriendly,
            this.adaptTableShapeDto(dto.shape),
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated)
        )
    }

    adaptTableShape(shape: TableShape): TableShapeDTO {
        switch (shape) {
            case TableShape.Rectangular:
                return TableShapeDTO.RECTANGULAR
            case TableShape.Round:
                return TableShapeDTO.ROUND
        }
    }

    adaptTableShapeDto(dto: TableShapeDTO): TableShape {
        switch (dto) {
            case TableShapeDTO.RECTANGULAR:
                return TableShape.Rectangular
            case TableShapeDTO.ROUND:
                return TableShape.Round
        }
    }

    adaptBookingReason(bookingReason: BookingReason): BookingReasonDTO {
        return new BookingReasonDTO(
            bookingReason.id,
            bookingReason.displayName,
            bookingReason.displayOrder,
            bookingReason.description,
            bookingReason.contributesToKitchenVelocity,
            bookingReason.schedule
                .map(reasonScheduleRule => this.adaptReasonScheduleRule(reasonScheduleRule)),
            bookingReason.dateRangeFilters
                .map(filter => this.adaptReasonDateRangeFilter(filter)),
            bookingReason.areaBookingOrder?.length ? [...bookingReason.areaBookingOrder] : null,
            bookingReason.bookingDurations.map(duration => this.adaptPartySizeDuration(duration)),
            bookingReason.diningInformation,
            bookingReason.minimumPartySize,
            bookingReason.maximumPartySize,
            bookingReason.linkExclusive,
            bookingReason.dailyCoverLimit,
            bookingReason.bookingLimit,
            bookingReason.coverLimit,
            bookingReason.cancellationChargeRanges.map(range => new ChargeRangeDTO(
                range.minPartySize,
                range.maxPartySize,
                range.unitAmount,
                range.isPerCover,
                range.startDate,
                range.endDate,
                range.cutOffHours
            )),
            bookingReason.depositChargeRanges.map(range => new ChargeRangeDTO(
                range.minPartySize,
                range.maxPartySize,
                range.unitAmount,
                range.isPerCover,
                range.startDate,
                range.endDate,
                range.cutOffHours
            )),
            bookingReason.largePartyNoAvailabilityMessage,
            bookingReason.merchantBookingsRequireChargeByDefault,
            bookingReason.preorderMenuId,
            bookingReason.sendPreOrderMenuId,
            bookingReason.sendPreOrderMenuMinPartySize,
            bookingReason.preBookingWindowMinutes,
            bookingReason.displayedOpeningTimes,
            bookingReason.reserveWithGoogleEnabled,
            bookingReason.imageId,
            bookingReason.calendarColour,
            bookingReason.isActive
        )
    }

    adaptBookingReasonDto(dto: BookingReasonDTO): BookingReason {
        return new BookingReason(
            dto.id,
            dto.displayName,
            dto.displayOrder,
            dto.description,
            dto.contributesToKitchenVelocity,
            dto.schedule.map(dto => this.adaptReasonScheduleRuleDto(dto)),
            dto.dateRangeFilters.map(dto => this.adaptReasonDateRangeFilterDto(dto)),
            dto.areaBookingOrder?.length ? [...dto.areaBookingOrder] : null,
            dto.bookingDurations.map(dto => this.adaptPartySizeDurationDto(dto)),
            dto.diningInformation,
            dto.minimumPartySize,
            dto.maximumPartySize,
            dto.linkExclusive,
            dto.dailyCoverLimit,
            dto.bookingLimit,
            dto.coverLimit,
            dto.cancellationChargeRanges.map(dto => new ChargeRange(
                dto.minPartySize,
                dto.maxPartySize,
                dto.unitAmount,
                dto.isPerCover,
                dto.startDate,
                dto.endDate,
                dto.cutOffHours
            )),
            dto.depositChargeRanges.map(dto => new ChargeRange(
                dto.minPartySize,
                dto.maxPartySize,
                dto.unitAmount,
                dto.isPerCover,
                dto.startDate,
                dto.endDate,
                dto.cutOffHours
            )),
            dto.largePartyNoAvailabilityMessage,
            dto.merchantBookingsRequireChargeByDefault,
            dto.preorderMenuId,
            dto.sendPreOrderMenuId,
            dto.sendPreOrderMenuMinPartySize,
            dto.preBookingWindowMinutes,
            dto.displayedOpeningTimes,
            dto.reserveWithGoogleEnabled ?? false,
            dto.imageId ?? null,
            dto.calendarColour ?? null,
            dto.isActive ?? true
        )
    }

    adaptCancellationReason(cancellationReason: CancellationReason): CancellationReasonDTO {
        return new CancellationReasonDTO(
            cancellationReason.id,
            cancellationReason.displayName,
            cancellationReason.orderIndex,
            cancellationReason.dateCreated.toISOString(),
            cancellationReason.dateUpdated.toISOString(),
            cancellationReason.isPublic
        )
    }

    adaptCancellationReasonDto(dto: CancellationReasonDTO): CancellationReason {
        return new CancellationReason(
            dto.id,
            dto.displayName,
            dto.orderIndex,
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated),
            dto.isPublic ?? true
        )
    }

    adaptReasonScheduleRule(reasonScheduleRule: ReasonScheduleRule): ReasonScheduleRuleDTO {
        return new ReasonScheduleRuleDTO(
            reasonScheduleRule.id,
            [...reasonScheduleRule.daysOfWeek],
            reasonScheduleRule.period ? this.adaptPeriod(reasonScheduleRule.period) : null,
            reasonScheduleRule.bookingDurations.map(duration => this.adaptPartySizeDuration(duration))
        )
    }

    adaptReasonScheduleRuleDto(dto: ReasonScheduleRuleDTO): ReasonScheduleRule {
        return new ReasonScheduleRule(
            dto.id,
            [...dto.daysOfWeek],
            dto.period ? this.adaptPeriodDto(dto.period) : null,
            dto.bookingDurations.map(dto => this.adaptPartySizeDurationDto(dto))
        )
    }

    adaptReasonDateRangeFilter(filter: ReasonDateRangeFilter): ReasonDateRangeFilterDTO {
        return new ReasonDateRangeFilterDTO(
            filter.id,
            this.adaptToLocalDateTime(filter.startDate),
            this.adaptToLocalDateTime(filter.endDate)
        )
    }

    adaptReasonDateRangeFilterDto(dto: ReasonDateRangeFilterDTO): ReasonDateRangeFilter {
        return new ReasonDateRangeFilter(
            dto.id,
            DateTime.fromISO(dto.startDate, { zone: environment.assumedVenueTimeZone }).toJSDate(),
            DateTime.fromISO(dto.endDate, { zone: environment.assumedVenueTimeZone }).toJSDate()
        )
    }

    adaptAddress(address: Address): AddressDTO {
        return new AddressDTO(
            address.addressLineOne,
            address.addressLineTwo,
            address.city,
            address.county,
            address.postCode,
            address.country
        )
    }

    adaptAddressDto(dto: AddressDTO): Address {
        return new Address(
            dto.addressLineOne,
            dto.addressLineTwo,
            dto.city,
            dto.county,
            dto.postCode,
            dto.country
        )
    }

    adaptBooking(booking: Booking): BookingDTO {
        const statusEvents = booking.statusEvents.map(status => {
            return this.adaptBookingStatus(status)
        })
        const answers = booking.answers.map(answer => {
            return this.adaptAnswer(answer)
        })
        return new BookingDTO(
            booking.id,
            booking.organisationId,
            booking.tableIds,
            this.adaptContact(booking.contact),
            booking.customer ? this.adaptCustomer(booking.customer) : null,
            booking.size,
            this.adaptToLocalDateTime(booking.start),
            booking.duration,
            booking.notes,
            booking.merchantNotes,
            booking.agreedToMarketing,
            booking.agreedToTerms,
            booking.paymentCustomerId,
            this.adaptBookingSource(booking.source),
            booking.reminders.map(reminder => this.adaptBookingReminder(reminder)),
            statusEvents,
            booking.feedbackRequests,
            booking.feedback,
            booking.reasonId,
            booking.eventId,
            answers,
            booking.cancellation ? this.adaptCancellation(booking.cancellation) : null,
            booking.deposit ? this.adaptDeposit(booking.deposit) : null,
            booking.sendFeedbackRequest,
            booking.requiresWheelchairAccess,
            booking.requiresDogFriendly,
            booking.requiresPramAccessible,
            booking.requiresHighchairFriendly,
            booking.lockedToTables,
            booking.serviceStatus !== null ? this.adaptServiceStatus(booking.serviceStatus) : null,
            booking.dateVoided?.toISOString() ?? null,
            booking.order ? this.adaptOrder(booking.order) : null,
            booking.docket ? this.adaptBookingDocket(booking.docket) : null,
            booking.sale ? {
                ...booking.sale,
                order: this.adaptOrder(booking.sale.order),
                dateCreated: booking.sale.dateCreated.toISOString(),
                dateUpdated: booking.sale.dateUpdated.toISOString(),
                deliveryDetails: booking.sale.deliveryDetails ? {
                    ...booking.sale.deliveryDetails,
                    postalDeliveryAddress: booking.sale.deliveryDetails.postalDeliveryAddress ? this.adaptAddress(booking.sale.deliveryDetails.postalDeliveryAddress) : null,
                } : null,
                payment: booking.sale.payment ? {
                    ...booking.sale.payment,
                    dateCreated: booking.sale.payment.dateCreated.toISOString(),
                    datePaid: booking.sale.payment.datePaid?.toISOString() ?? null,
                    refunds: booking.sale.payment.refunds.map(refund => ({ ...refund, dateCreated: refund.dateCreated.toISOString() })),
                } : null,
            } : null
        )
    }

    private adaptOrder(order: Order): OrderDTO {
        return new OrderDTO(
            order.id,
            order.venueId,
            order.lineItems.map(lineItem => this.adaptLineItem(lineItem)),
            order.currencyCode,
            order.message,
            order.dateCreated.toISOString(),
            order.dateUpdated.toISOString(),
            order.isPaid
        )
    }

    private adaptLineItem(lineItem: LineItem): LineItemDTO {
        return new LineItemDTO(
            lineItem.id,
            lineItem.productId,
            lineItem.skuId,
            lineItem.name,
            lineItem.amount,
            lineItem.quantity,
            lineItem.modifiers.map(m => this.adaptLineItemModifier(m)),
            lineItem.externalReference,
            lineItem.dateCreated.toISOString(),
            lineItem.dateUpdated.toISOString(),
            lineItem.customerRefundableUntil?.toISOString() ?? null,
            lineItem.paidOnline
        )
    }

    private adaptLineItemModifier(modifier: LineItemModifier): LineItemModifierDTO {
        return new LineItemModifierDTO(
            modifier.id,
            modifier.productId,
            modifier.skuId,
            modifier.name,
            modifier.amount,
            modifier.quantity,
            modifier.dateCreated.toISOString(),
            modifier.dateUpdated.toISOString()
        )
    }

    adaptBookingDto(dto: BookingDTO, timeZone = environment.assumedVenueTimeZone): Booking {
        const statusEvents = dto.statusEvents.map(dto => {
            return this.adaptBookingStatusDto(dto)
        })
        const answers = dto.answers.map(dto => {
            return this.adaptAnswerDto(dto)
        })
        const start = DateTime.fromISO(dto.start, {zone: timeZone})
            .toJSDate()
        return new Booking(
            dto.id,
            dto.organisationId,
            dto.tableIds,
            this.adaptContactDto(dto.contact),
            dto.customer ? this.adaptCustomerDto(dto.customer) : null,
            dto.size,
            start,
            dto.durationMinutes,
            dto.notes,
            dto.merchantNotes,
            dto.agreedToMarketing,
            dto.agreedToTerms,
            dto.paymentCustomerId,
            this.adaptBookingSourceDto(dto.source),
            dto.reminders.map(dto => this.adaptBookingReminderDto(dto)),
            statusEvents,
            dto.feedbackRequests,
            dto.feedback,
            dto.reasonId,
            dto.eventId,
            answers,
            dto.cancellation ? this.adaptCancellationDto(dto.cancellation) : null,
            dto.deposit ? this.adaptDepositDto(dto.deposit) : null,
            dto.sendFeedbackRequest,
            dto.requiresWheelchairAccess,
            dto.requiresDogFriendly,
            dto.requiresPramAccessible,
            dto.requiresHighchairFriendly,
            dto.lockedToTables,
            dto.serviceStatus ? this.adaptServiceStatusDto(dto.serviceStatus) : null,
            dto.dateVoided ? new Date(dto.dateVoided) : null,
            dto.order ? this.adaptOrderDto(dto.order) : null,
            dto.docket ? this.adaptBookingDocketDto(dto.docket) : null,
            dto.sale ? this.adaptSaleDto(dto.sale) : null
        )
    }

    adaptBookingDocket(docket: BookingDocket): BookingDocketDTO {
        return new BookingDocketDTO(
            docket.id,
            docket.menuId,
            docket.coverChoices.map(choice => this.adaptCoverMenuChoice(choice)),
            docket.dateCreated.toISOString(),
            docket.dateUpdated.toISOString(),
            docket.minimumCoursesRequired,
            docket.maximumCoursesRequired
        )
    }

    private adaptBookingDocketDto(dto: BookingDocketDTO): BookingDocket {
        return new BookingDocket(
            dto.id,
            dto.menuId,
            dto.coverChoices.map(choice => this.adaptCoverMenuChoiceDto(choice)),
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated),
            dto.minimumCoursesRequired ?? null,
            dto.maximumCoursesRequired ?? null
        )
    }

    private adaptCoverMenuChoice(choice: CoverMenuChoice): CoverMenuChoiceDTO {
        return new CoverMenuChoiceDTO(
            choice.name ? choice.name : null,
            choice.notes ? choice.notes : null,
            choice.selections.map(sel => new CoverProductSelectionDTO(
                sel.productSkuId,
                [...sel.modifierSkuIds],
                sel.menuItemId ?? null
            ))
        )
    }

    private adaptCoverMenuChoiceDto(dto: CoverMenuChoiceDTO): CoverMenuChoice {
        return new CoverMenuChoice(
            dto.name ? dto.name : null,
            dto.notes ? dto.notes : null,
            dto.selections.map(sel => new CoverProductSelection(
                sel.productSkuId,
                [...sel.modifierSkuIds],
                sel.menuItemId ?? null
            ))
        )
    }

    adaptBookingStatus(status: BookingStatus): BookingStatusDTO {
        return new BookingStatusDTO(
            status.id,
            Object.fromEntries(status.metadata),
            status.dateTime.toISOString(),
            this.adaptBookingStatusType(status.type)
        )
    }

    adaptBookingStatusDto(dto: BookingStatusDTO): BookingStatus {
        return new BookingStatus(
            dto.id,
            new Map(Object.entries(dto.metadata)),
            new Date(dto.dateTime),
            this.adaptBookingStatusTypeDto(dto.type)
        )
    }

    adaptBookingStatusType(type: BookingStatusType): BookingStatusTypeDTO {
        switch (type) {
            case BookingStatusType.Requested:
                return BookingStatusTypeDTO.Requested
            case BookingStatusType.PendingPayment:
                return BookingStatusTypeDTO.PendingPayment
            case BookingStatusType.Booked:
                return BookingStatusTypeDTO.Booked
            case BookingStatusType.Cancelled:
                return BookingStatusTypeDTO.Cancelled
            case BookingStatusType.NoShow:
                return BookingStatusTypeDTO.NoShow
            case BookingStatusType.Waiting:
                return BookingStatusTypeDTO.Waiting
            case BookingStatusType.PartiallySeated:
                return BookingStatusTypeDTO.PartiallySeated
            case BookingStatusType.Seated:
                return BookingStatusTypeDTO.Seated
            case BookingStatusType.Finished:
                return BookingStatusTypeDTO.Finished
            case BookingStatusType.Rejected:
                return BookingStatusTypeDTO.Rejected
        }
    }

    adaptBookingStatusTypeDto(dto: BookingStatusTypeDTO): BookingStatusType {
        switch (dto) {
            case BookingStatusTypeDTO.Requested:
                return BookingStatusType.Requested
            case BookingStatusTypeDTO.PendingPayment:
                return BookingStatusType.PendingPayment
            case BookingStatusTypeDTO.Booked:
                return BookingStatusType.Booked
            case BookingStatusTypeDTO.Cancelled:
                return BookingStatusType.Cancelled
            case BookingStatusTypeDTO.NoShow:
                return BookingStatusType.NoShow
            case BookingStatusTypeDTO.Waiting:
                return BookingStatusType.Waiting
            case BookingStatusTypeDTO.PartiallySeated:
                return BookingStatusType.PartiallySeated
            case BookingStatusTypeDTO.Seated:
                return BookingStatusType.Seated
            case BookingStatusTypeDTO.Finished:
                return BookingStatusType.Finished
            case BookingStatusTypeDTO.Rejected:
                return BookingStatusType.Rejected
        }
    }

    adaptBookingSource(source: BookingSource): BookingSourceDTO {
        switch (source) {
            case BookingSource.Customer:
                return BookingSourceDTO.Customer
            case BookingSource.Google:
                return BookingSourceDTO.Google
            case BookingSource.Merchant:
                return BookingSourceDTO.Merchant
        }
    }

    adaptBookingSourceDto(dto: BookingSourceDTO): BookingSource {
        switch (dto) {
            case BookingSourceDTO.Customer:
                return BookingSource.Customer
            case BookingSourceDTO.Google:
                return BookingSource.Google
            case BookingSourceDTO.Merchant:
                return BookingSource.Merchant
        }
    }

    adaptServiceStatus(status: ServiceStatus): ServiceStatusDTO {
        switch (status) {
        case ServiceStatus.Unseated:
            return ServiceStatusDTO.Unseated
        case ServiceStatus.Drinks:
            return ServiceStatusDTO.Drinks
        case ServiceStatus.Starter:
            return ServiceStatusDTO.Starter
        case ServiceStatus.Main:
            return ServiceStatusDTO.Main
        case ServiceStatus.Dessert:
            return ServiceStatusDTO.Dessert
        case ServiceStatus.Bill:
            return ServiceStatusDTO.Bill
        case ServiceStatus.Cleaning:
            return ServiceStatusDTO.Cleaning
        case ServiceStatus.Paid:
            return ServiceStatusDTO.Paid
        case ServiceStatus.Closed:
            return ServiceStatusDTO.Closed
        }
    }

    adaptServiceStatusDto(dto: ServiceStatusDTO): ServiceStatus {
        switch (dto) {
        case ServiceStatusDTO.Unseated:
            return ServiceStatus.Unseated
        case ServiceStatusDTO.Drinks:
            return ServiceStatus.Drinks
        case ServiceStatusDTO.Starter:
            return ServiceStatus.Starter
        case ServiceStatusDTO.Main:
            return ServiceStatus.Main
        case ServiceStatusDTO.Dessert:
            return ServiceStatus.Dessert
        case ServiceStatusDTO.Bill:
            return ServiceStatus.Bill
        case ServiceStatusDTO.Cleaning:
            return ServiceStatus.Cleaning
        case ServiceStatusDTO.Paid:
            return ServiceStatus.Paid
        case ServiceStatusDTO.Closed:
            return ServiceStatus.Closed
        }
    }

    adaptContact(contact: Contact): ContactDTO {
        return new ContactDTO(
            contact.firstName,
            contact.lastName,
            contact.emailAddress,
            contact.phoneNumber
        )
    }

    adaptContactDto(dto: ContactDTO): Contact {
        return new Contact(
            dto.firstName,
            dto.lastName,
            dto.emailAddress,
            dto.phoneNumber
        )
    }

    adaptBookingReminder(reminder: BookingReminder): BookingReminderDTO {
        return new BookingReminderDTO(
            reminder.id,
            reminder.sentDateTime.toISOString(),
            reminder.confirmedDateTime ? reminder.confirmedDateTime.toISOString() : null
        )
    }

    adaptBookingReminderDto(dto: BookingReminderDTO): BookingReminder {
        return new BookingReminder(
            dto.id,
            new Date(dto.sentDateTime),
            dto.confirmedDateTime ? new Date(dto.confirmedDateTime) : null
        )
    }

    adaptCancellation(cancellation: Cancellation): CancellationDTO {
        return new CancellationDTO(
            cancellation.id,
            cancellation.paymentMethodId,
            cancellation.unitAmount,
            cancellation.currencyCode,
            cancellation.isPerCover,
            cancellation.partySize,
            cancellation.cutOffHours !== null ? cancellation.cutOffHours : null,
            cancellation.chargeAutomatically,
            cancellation.charges.map(charge => this.adaptCancellationCharge(charge)),
            cancellation.dateCreated.toISOString(),
            cancellation.paymentsAccountId
        )
    }

    adaptCancellationDto(dto: CancellationDTO): Cancellation {
        return new Cancellation(
            dto.id,
            dto.paymentMethodId,
            dto.unitAmount,
            dto.currencyCode,
            dto.isPerCover,
            dto.partySize,
            dto.cutOffHours !== null ? dto.cutOffHours : null,
            dto.chargeAutomatically,
            dto.charges.map(dto => this.adaptCancellationChargeDto(dto)),
            new Date(dto.dateCreated),
            dto.paymentsAccountId
        )
    }

    adaptCancellationCharge(charge: CancellationCharge): CancellationChargeDTO {
        return new CancellationChargeDTO(
            charge.id,
            charge.amount,
            charge.currencyCode,
            charge.partySize,
            charge.paymentIntentId,
            charge.dateCreated.toISOString(),
            charge.dateRefunded ? charge.dateRefunded.toISOString() : null
        )
    }

    adaptCancellationChargeDto(dto: CancellationChargeDTO): CancellationCharge {
        return new CancellationCharge(
            dto.id,
            dto.amount,
            dto.currencyCode,
            dto.partySize,
            dto.paymentIntentId,
            new Date(dto.dateCreated),
            dto.dateRefunded ? new Date(dto.dateRefunded) : null
        )
    }

    adaptDeposit(deposit: Deposit): DepositDTO {
        return new DepositDTO(
            deposit.id,
            deposit.paymentMethodId,
            deposit.amount,
            deposit.currencyCode,
            deposit.payments.map(p => this.adaptDepositPayment(p)),
            deposit.dateCreated.toISOString()
        )
    }

    adaptDepositPayment(payment: DepositPayment): DepositPaymentDTO {
        return new DepositPaymentDTO(
            payment.id,
            payment.amount,
            payment.currencyCode,
            payment.partySize,
            payment.paymentIntentId,
            payment.dateCreated.toISOString(),
            payment.dateRefunded ? payment.dateRefunded.toISOString() : null,
            payment.refundedAmount()
        )
    }

    adaptDepositDto(dto: DepositDTO): Deposit {
        return new Deposit(
            dto.id,
            dto.paymentMethodId,
            dto.amount,
            dto.currencyCode,
            dto.payments.map(p => this.adaptDepositPaymentDto(p)),
            new Date(dto.dateCreated)
        )
    }

    adaptDepositPaymentDto(dto: DepositPaymentDTO): DepositPayment {
        return new DepositPayment(
            dto.id,
            dto.amount,
            dto.currencyCode,
            dto.partySize,
            dto.paymentIntentId,
            new Date(dto.dateCreated),
            dto.dateRefunded ? new Date(dto.dateRefunded) : null,
            dto.amountRefunded ?? 0
        )
    }

    adaptUser(user: BaseUser | AccountUser): UserDTO {
        const emailAddress = user instanceof AccountUser ? user.emailAddress : null
        const role = user instanceof AccountUser ? this.adaptUserRole(user.role) : null
        return new UserDTO(
            user.id,
            user.name,
            emailAddress,
            role,
            user.venueIds ? [...user.venueIds] : null,
            user.notificationPreferences.map(pref => this.adaptUserNotificationPreferences(pref)),
            user.pinCode
        )
    }

    adaptUserRole(role: UserRole): UserRoleDTO {
        switch (role) {
            case UserRole.OWNER:
                return UserRoleDTO.OWNER
            case UserRole.MANAGER:
                return UserRoleDTO.MANAGER
            case UserRole.STAFF:
                return UserRoleDTO.STAFF
            case UserRole.VIEWER:
                return UserRoleDTO.VIEWER
        }
    }

    adaptUserNotificationPreferences(notificationPreferences: UserNotificationPreferences): UserNotificationPreferencesDTO {
        return new UserNotificationPreferencesDTO(
            notificationPreferences.venueId,
            notificationPreferences.bookingRequests
        )
    }

    adaptUserDto(dto: UserDTO): BaseUser | AccountUser {
        const notificationPreferences = dto.notificationPreferences.map(dto =>
            this.adaptUserNotificationPreferencesDto(dto)
        )
        const emailAddress = dto.emailAddress
        const role = dto.role ? this.adaptUserRoleDto(dto.role) : null
        if (emailAddress !== null && role !== null) {
            return new AccountUser(
                dto.id,
                dto.name,
                emailAddress,
                role,
                dto.venueIds ? [...dto.venueIds] : null,
                notificationPreferences,
                dto.pinCode
            )
        }
        return new BaseUser(
            dto.id,
            dto.name,
            dto.venueIds ? [...dto.venueIds] : null,
            notificationPreferences,
            dto.pinCode
        )
    }

    adaptUserRoleDto(dto: UserRoleDTO): UserRole {
        switch (dto) {
            case UserRoleDTO.OWNER:
                return UserRole.OWNER
            case UserRoleDTO.MANAGER:
                return UserRole.MANAGER
            case UserRoleDTO.STAFF:
                return UserRole.STAFF
            case UserRoleDTO.VIEWER:
                return UserRole.VIEWER
        }
    }

    adaptUserNotificationPreferencesDto(dto: UserNotificationPreferencesDTO): UserNotificationPreferences {
        return new UserNotificationPreferences(
            dto.venueId,
            dto.bookingRequests
        )
    }

    adaptVenueSchedule(venueSchedule: VenueSchedule): VenueScheduleDTO {
        const diaryNotes = venueSchedule.diaryNotes.map(note => this.adaptDiaryNote(note))
        const areas = venueSchedule.areas.map(area => this.adaptAreaSchedule(area))
        areas.sort((a, b) => a.area.displayOrder - b.area.displayOrder)
        const bookingSlotVelocityLimitOverrides = venueSchedule.bookingSlotVelocityLimitOverrides.map(
            override => this.adaptBookingSlotVelocityLimitOverride(override)
        )
        return new VenueScheduleDTO(
            diaryNotes,
            areas,
            bookingSlotVelocityLimitOverrides
        )
    }

    adaptBookingSlotVelocityLimitOverride(override: BookingSlotVelocityLimitOverride): BookingSlotVelocityLimitOverrideDTO {
        return new BookingSlotVelocityLimitOverrideDTO(
            override.id,
            this.adaptToLocalDateTime(override.startDateTime),
            override.bookingLimit,
            override.coverLimit,
            override.reasonId,
            override.eventId
        )
    }

    adaptVenueScheduleDto(dto: VenueScheduleDTO): VenueSchedule {
        const diaryNotes = dto.diaryNotes.map(note => this.adaptDiaryNoteDto(note))
        const areas = dto.areaSchedules.map(dto => this.adaptAreaScheduleDto(dto))
        areas.sort((a, b) => a.area.displayOrder - b.area.displayOrder)
        const bookingSlotVelocityLimitOverrides = dto.bookingSlotVelocityLimitOverrides.map(
            override => this.adaptBookingSlotVelocityLimitOverrideDto(override)
        )
        return new VenueSchedule(
            diaryNotes,
            areas,
            bookingSlotVelocityLimitOverrides
        )
    }

    adaptBookingSlotVelocityLimitOverrideDto(dto: BookingSlotVelocityLimitOverrideDTO): BookingSlotVelocityLimitOverride {
        return new BookingSlotVelocityLimitOverride(
            dto.id,
            DateTime.fromISO(dto.startDateTime, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            dto.bookingLimit,
            dto.coverLimit,
            dto.reasonId,
            dto.eventId
        )
    }

    adaptDiaryNoteDto(dto: DiaryNoteDTO): DiaryNote {
        return new DiaryNote(
            dto.id,
            DateTime.fromISO(dto.startDate, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            DateTime.fromISO(dto.endDate, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            dto.note,
            dto.title,
            dto.startTime ? new Time(dto.startTime, null, null) : null,
            dto.durationMinutes,
            dto.contact ? this.adaptContactDto(dto.contact) : null,
            dto.isPublic
        )
    }

    adaptDiaryNote(note: DiaryNote): DiaryNoteDTO {
        return new DiaryNoteDTO(
            note.id,
            this.adaptToLocalDate(note.startDate),
            this.adaptToLocalDate(note.endDate),
            note.note,
            note.title,
            note.startTime ? note.startTime.toString() : null,
            note.durationMinutes,
            note.contact ? this.adaptContact(note.contact) : null,
            note.isPublic
        )
    }

    adaptAreaSchedule(areaSchedule: AreaSchedule): AreaScheduleDTO {
        const area = this.adaptArea(areaSchedule.area)
        const closures = areaSchedule.closures.map(closure => this.adaptVenueClosure(closure))
        return new AreaScheduleDTO(
            area,
            closures
        )
    }

    adaptAreaScheduleDto(dto: AreaScheduleDTO): AreaSchedule {
        const area = this.adaptAreaDto(dto.area)
        const closures = dto.closures.map(dto => this.adaptVenueClosureDto(dto))
        return new AreaSchedule(area, closures)
    }

    adaptVenueClosure(venueClosure: VenueClosure): VenueClosureDTO {
        return new VenueClosureDTO(
            venueClosure.id,
            this.adaptToLocalDateTime(venueClosure.start),
            this.adaptToLocalDateTime(venueClosure.end),
            [...venueClosure.tableIds],
            [...venueClosure.reasonIds],
            venueClosure.closes,
            venueClosure.description,
            venueClosure.dateCreated.toISOString()
        )
    }

    adaptVenueClosureDto(dto: VenueClosureDTO): VenueClosure {
        return new VenueClosure(
            dto.id,
            DateTime.fromISO(dto.start, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            DateTime.fromISO(dto.end, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            [...dto.tableIds],
            [...dto.reasonIds],
            dto.closes,
            dto.description,
            DateTime.fromISO(dto.dateCreated, {zone: environment.assumedVenueTimeZone}).toJSDate()
        )
    }

    adaptSchedule(schedule: Schedule): ScheduleDTO {
        const dateRanges = schedule.dateRanges.map(dateRange => {
            return {
                first: dateRange.start ? this.adaptToLocalDateTime(dateRange.start) : null,
                second: dateRange.end ? this.adaptToLocalDateTime(dateRange.end) : null,
            }
        })
        const durations = schedule.bookingDurations.map(duration => {
            return this.adaptPartySizeDuration(duration)
        })
        const serviceDtos = schedule.services.map(service => {
            return this.adaptService(service)
        })
        const exceptionDtos = schedule.exceptions.map(exception => {
            return this.adaptScheduleException(exception)
        })
        return new ScheduleDTO(
            schedule.id,
            schedule.displayName,
            dateRanges,
            schedule.preBookingWindowMinutes,
            schedule.preBookingModificationWindowMinutes,
            schedule.inAdvanceBookingLimitDays,
            schedule.coverVelocity,
            durations,
            serviceDtos,
            exceptionDtos
        )
    }

    adaptScheduleDto(dto: ScheduleDTO): Schedule {
        const dateRanges = dto.dateRanges.map(dateRange => {
            return {
                start: dateRange.first ? new Date(dateRange.first) : null,
                end: dateRange.second ? new Date(dateRange.second) : null,
            }
        })
        const durations = dto.bookingDurations.map(dto => this.adaptPartySizeDurationDto(dto))
        const services = dto.services.map(dto => this.adaptServiceDto(dto))
        const exceptions = dto.exceptions.map(dto => this.adaptScheduleExceptionDto(dto))
        return new Schedule(
            dto.id,
            dto.displayName,
            dateRanges,
            dto.preBookingWindowMinutes,
            dto.preBookingModificationWindowMinutes,
            dto.inAdvanceBookingLimitDays,
            dto.coverVelocity,
            durations,
            services,
            exceptions
        )
    }

    adaptService(service: Service): ServiceDTO {
        const rules = service.rules.map(rule => this.adaptScheduleRule(rule))
        return new ServiceDTO(
            service.id,
            service.displayName,
            rules
        )
    }

    adaptServiceDto(dto: ServiceDTO): Service {
        const rules = dto.rules.map(dto => this.adaptScheduleRuleDto(dto))
        return new Service(
            dto.id,
            dto.displayName,
            rules
        )
    }

    adaptScheduleRule(rule: ScheduleRule): ScheduleRuleDTO {
        const durations = rule.bookingDurations.map(duration => {
            return this.adaptPartySizeDuration(duration)
        })
        return new ScheduleRuleDTO(
            rule.id,
            rule.dateComponents.map(component => this.adaptDateComponent(component)),
            this.adaptPeriod(rule.period),
            durations,
            rule.paymentsEnabled,
            rule.preBookingWindowMinutes,
            rule.coverLimit,
            rule.manualAcceptance
        )
    }

    adaptScheduleRuleDto(dto: ScheduleRuleDTO): ScheduleRule {
        const durations = dto.bookingDurations.map(dto => this.adaptPartySizeDurationDto(dto))
        return new ScheduleRule(
            dto.id,
            dto.dateComponents.map(dto => this.adaptDateComponentDto(dto)),
            this.adaptPeriodDto(dto.period),
            durations,
            dto.paymentsEnabled,
            dto.preBookingWindowMinutes,
            dto.coverLimit,
            dto.manualAcceptance
        )
    }

    adaptScheduleException(exception: ScheduleException): ScheduleExceptionDTO {
        return new ScheduleExceptionDTO(
            exception.id,
            this.adaptToLocalDate(exception.startDate),
            this.adaptToLocalDate(exception.endDate),
            exception.description
        )
    }

    adaptScheduleExceptionDto(dto: ScheduleExceptionDTO): ScheduleException {
        return new ScheduleException(
            dto.id,
            DateTime.fromISO(dto.startDate, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            DateTime.fromISO(dto.endDate, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            dto.description
        )
    }

    adaptPeriod(period: Period): PeriodDTO {
        return new PeriodDTO(
            period.start.toString(),
            period.end.toString(),
            period.open
        )
    }

    adaptPeriodDto(dto: PeriodDTO): Period {
        return new Period(
            new Time(dto.start, null, null),
            new Time(dto.end, null, null),
            dto.open
        )
    }

    adaptDateComponent(component: DateComponent): DateComponentDTO {
        return new DateComponentDTO(
            component.unit,
            component.value
        )
    }

    adaptDateComponentDto(dto: DateComponentDTO): DateComponent {
        return new DateComponent(
            dto.unit,
            dto.value
        )
    }

    adaptBookingsReportGraphDto(dto: BookingsReportGraphDTO): BookingsReportGraph {
        const date = new Date(dto.bookingsDate)
        date.setHours(0, 0, 0, 0)
        return new BookingsReportGraph(
            date,
            dto.totalBookings
        )
    }

    adaptBookingsReportDataDto(dto: BookingsReportDataDTO): BookingsReportData {
        return new BookingsReportData(
            dto.bookingId,
            this.adaptBookingStatusTypeDto(dto.statusType),
            dto.venueName,
            dto.areaName,
            dto.tableName,
            dto.size,
            new Date(dto.start),
            dto.durationMinutes,
            dto.reasonId
        )
    }

    adaptCancellationsReportDataDto(dto: CancellationsReportDataDTO): CancellationsReportData {
        return new CancellationsReportData(
            dto.bookingId,
            dto.firstName,
            dto.lastName,
            dto.emailAddress,
            dto.partySize,
            new Date(dto.bookingStart),
            new Date(dto.cancelledAt),
            dto.cancellationReasonId,
            dto.cancellationReasonDisplayName
        )
    }

    adaptVoidedBookingDto(dto: VoidedBookingDTO): VoidedBooking {
        return new VoidedBooking(
            this.adaptBookingDto(dto.booking),
            dto.voidedByUserId,
            dto.voidedByUserEmailAddress
        )
    }

    adaptDepositsReportDataDto(dto: DepositsReportDataDTO): DepositsReportData {
        return new DepositsReportData(
            dto.bookingId,
            dto.reasonId,
            new Date(dto.start),
            DineroFactory({
                amount: dto.amount,
                currency: dto.currencyCode as DineroFactory.Currency,
            }),
            dto.partySize,
            this.adaptContactDto(dto.contact),
            new Date(dto.datePaid),
            dto.dateRefunded ? new Date(dto.dateRefunded) : null
        )
    }

    adaptDepositsReportGraphDto(dto: DepositsReportGraphDTO): DepositsReportGraph {
        return new DepositsReportGraph(
            new Date(dto.date),
            dto.grossCount,
            dto.netCount,
            dto.grossAmount,
            dto.netAmount,
            dto.currencyCode
        )
    }

    adaptSMSUsageReportDataDto(dto: SMSUsageReportDataDTO): SMSUsageReportData {
        return new SMSUsageReportData(
            dto.monthStartDate,
            dto.totalMessages
        )
    }

    adaptBillingDetails(billingDetails: BillingDetails): BillingDetailsDTO {
        return new BillingDetailsDTO(
            billingDetails.inService,
            billingDetails.needsToUpgradeTrial,
            billingDetails.nextBillingPeriod,
            billingDetails.nextBillingAmount,
            billingDetails.nextBillingAmountCurrencyCode,
            billingDetails.nextBillingDate,
            [...billingDetails.addons],
            [...billingDetails.entitlements],
            Object.fromEntries(
                Object.entries(billingDetails.quantityEntitlements)
                    .map(([entitlement, value]) => [entitlement, { ...value }])
            )
        )
    }

    adaptBillingDetailsDto(dto: BillingDetailsDTO): BillingDetails {
        const nextBillingDate = dto.nextBillingDate ? new Date(dto.nextBillingDate) : null
        return new BillingDetails(
            dto.inService,
            dto.needsToUpgradeTrial,
            dto.nextBillingPeriod,
            dto.nextBillingAmount,
            dto.nextBillingAmountCurrencyCode,
            nextBillingDate,
            [...dto.addons],
            [...(dto.entitlements ?? [])],
            Object.fromEntries(
                Object.entries(dto.quantityEntitlements ?? {})
                    .map(([entitlement, value]) => [entitlement, { ...value }])
            )
        )
    }

    adaptPaymentsAccount(paymentsAccount: PaymentsAccount): PaymentsAccountDTO {
        return new PaymentsAccountDTO(
            paymentsAccount.id,
            paymentsAccount.currencyCode,
            paymentsAccount.depositApplicationFeePercent,
            paymentsAccount.cancellationChargeApplicationFeePercent,
            paymentsAccount.voucherApplicationFeePercent,
            paymentsAccount.processingFeePercent,
            paymentsAccount.processingFeeUnitAmount,
            paymentsAccount.gateway,
            paymentsAccount.apiKey ? paymentsAccount.apiKey : null,
            paymentsAccount.applePayWebDomains.map(webDomain => this.adaptApplePayWebDomain(webDomain)),
            paymentsAccount.applePayEnabled,
            paymentsAccount.active,
            paymentsAccount.dateDisconnected?.toISOString() ?? null,
            paymentsAccount.capabilities,
            paymentsAccount.orderApplicationFeePercent
        )
    }

    adaptPaymentsAccountDto(dto: PaymentsAccountDTO): PaymentsAccount {
        return new PaymentsAccount(
            dto.id,
            dto.currencyCode,
            dto.depositApplicationFeePercent,
            dto.cancellationChargeApplicationFeePercent,
            dto.voucherApplicationFeePercent,
            dto.processingFeePercent,
            dto.processingFeeUnitAmount,
            dto.gateway,
            dto.apiKey ? dto.apiKey : null,
            dto.applePayWebDomains.map(webDomainDto => this.adaptApplePayWebDomainDto(webDomainDto)),
            dto.applePayEnabled,
            dto.active,
            dto.dateDisconnected ? new Date(dto.dateDisconnected) : null,
            dto.capabilities,
            dto.orderApplicationFeePercent ?? dto.depositApplicationFeePercent
        )
    }

    adaptApplePayWebDomain(webDomain: ApplePayWebDomain): ApplePayWebDomainDTO {
        return new ApplePayWebDomainDTO(
            webDomain.id,
            webDomain.domain
        )
    }

    adaptApplePayWebDomainDto(dto: ApplePayWebDomainDTO): ApplePayWebDomain {
        return new ApplePayWebDomain(
            dto.id,
            dto.domain
        )
    }

    adaptPaymentsAccountDetailsDto(dto: PaymentsAccountDetailsDTO): PaymentsAccountDetails {
        return new PaymentsAccountDetails(
            dto.chargesEnabled,
            dto.verificationStatus ? this.adaptPaymentsAccountVerificationStatusDto(dto.verificationStatus) : null,
            dto.accountSignupLink
        )
    }

    adaptPaymentsAccountDetails(
        paymentsAccountDetails: PaymentsAccountDetails
    ): PaymentsAccountDetailsDTO {
        return new PaymentsAccountDetailsDTO(
            paymentsAccountDetails.chargesEnabled,
            paymentsAccountDetails.verificationStatus
                ? this.adaptPaymentsAccountVerificationStatus(paymentsAccountDetails.verificationStatus) : null,
            paymentsAccountDetails.accountSignupLink
        )
    }

    private adaptPaymentsAccountVerificationStatus(
        verificationStatus: PaymentsAccountVerificationStatus
    ): PaymentsAccountVerificationStatusDTO {
        switch (verificationStatus) {
            case PaymentsAccountVerificationStatus.NotRequired:
                return PaymentsAccountVerificationStatusDTO.NotRequired
            case PaymentsAccountVerificationStatus.Required:
                return PaymentsAccountVerificationStatusDTO.Required
            case PaymentsAccountVerificationStatus.PendingVerification:
                return PaymentsAccountVerificationStatusDTO.PendingVerification
            case PaymentsAccountVerificationStatus.Verified:
                return PaymentsAccountVerificationStatusDTO.Verified
        }
    }

    private adaptPaymentsAccountVerificationStatusDto(
        dto: PaymentsAccountVerificationStatusDTO
    ): PaymentsAccountVerificationStatus {
        switch (dto) {
            case PaymentsAccountVerificationStatusDTO.NotRequired:
                return PaymentsAccountVerificationStatus.NotRequired
            case PaymentsAccountVerificationStatusDTO.Required:
                return PaymentsAccountVerificationStatus.Required
            case PaymentsAccountVerificationStatusDTO.PendingVerification:
                return PaymentsAccountVerificationStatus.PendingVerification
            case PaymentsAccountVerificationStatusDTO.Verified:
                return PaymentsAccountVerificationStatus.Verified
        }
    }

    adaptBookingSlot(bookingSlot: BookingSlot): BookingSlotDTO {
        return new BookingSlotDTO(this.adaptToLocalDateTime(bookingSlot.dateTime))
    }

    adaptBookingSlotDto(dto: BookingSlotDTO): BookingSlot {
        return new BookingSlot(
            DateTime.fromISO(dto.dateTime, {zone: environment.assumedVenueTimeZone})
                .toJSDate()
        )
    }

    private adaptToLocalDateTime(date: Date): string {
        return DateTime.fromJSDate(date, {zone: environment.assumedVenueTimeZone})
            .toISO({
                includeOffset: false,
                includePrefix: true,
            })!
    }

    private adaptToLocalDate(date: Date): string {
        return DateTime.fromJSDate(date, {zone: environment.assumedVenueTimeZone})
            .toISODate()!
    }

    adaptBookingsFeedbackReportDataDto(
        dto: BookingsFeedbackReportDataDTO
    ): BookingsFeedbackReportData {
        return new BookingsFeedbackReportData(
            dto.feedbackId,
            dto.firstName,
            dto.lastName,
            dto.emailAddress,
            new Date(dto.startTime),
            dto.rating,
            dto.food,
            dto.service,
            dto.atmosphere,
            dto.comment,
            dto.isRedirectedExternally,
            new Date(dto.feedbackDateCreated)
        )
    }

    adaptCustomerListExportDto(
        dto: CustomerListExportDataDTO
    ): CustomerListExportData {
        const contact = new Contact(
            dto.firstName,
            dto.lastName,
            dto.emailAddress,
            dto.phoneNumber
        )
        return new CustomerListExportData(
            dto.bookingId,
            contact,
            dto.bookingSize,
            dto.bookingStartTime,
            dto.agreedToMarketing,
            this.adaptBookingSourceDto(dto.source)
        )
    }

    adaptBookingsPerHourReportDataDto(
        dto: BookingsPerHourReportDataDTO
    ): BookingsPerHourReportData {
        return new BookingsPerHourReportData(
            dto.bookingHour,
            dto.customerMinBookings,
            dto.customerAvgBookings,
            dto.customerMaxBookings,
            dto.merchantMinBookings,
            dto.merchantAvgBookings,
            dto.merchantMaxBookings,
            dto.walkinMinBookings,
            dto.walkinAvgBookings,
            dto.walkinMaxBookings
        )
    }

    adaptBookingsPerServiceReportDataDto(
        dto: BookingsPerServiceReportDataDTO
    ): BookingsPerServiceReportData {
        return new BookingsPerServiceReportData(
            dto.date,
            dto.serviceId,
            dto.serviceName,
            dto.totalBookings,
            dto.totalCovers,
            dto.customerBookings,
            dto.customerCovers,
            dto.merchantBookings,
            dto.merchantCovers,
            dto.walkinBookings,
            dto.walkinCovers
        )
    }

    adaptGiftVoucherActivityReportDataDto(
        dto: GiftVoucherActivityReportDataDTO
    ): GiftVoucherActivityReportData {
        return new GiftVoucherActivityReportData(
            dto.activityType as unknown as GiftVoucherActivityType,
            new Date(dto.activityDate),
            dto.giftedVoucherId,
            dto.lineItemId,
            dto.shortCode ?? null,
            dto.voucherName,
            dto.venueId,
            dto.venueDisplayName,
            dto.currencyCode,
            DineroFactory({
                amount: dto.voucherValue,
                currency: dto.currencyCode as DineroFactory.Currency,
            }),
            dto.merchantSalesValue !== null
                ? DineroFactory({
                    amount: dto.merchantSalesValue,
                    currency: dto.currencyCode as DineroFactory.Currency,
                })
                : null
        )
    }

    adaptCreateUserRequest(createUserRequest: CreateUserRequest): CreateUserRequestDTO {
        const role = createUserRequest.role
        return new CreateUserRequestDTO(
            createUserRequest.name,
            createUserRequest.emailAddress,
            role !== undefined ? this.adaptUserRole(role) : undefined,
            createUserRequest.password,
        )
    }

    adaptCreateUserRequestDto(dto: CreateUserRequestDTO): CreateUserRequest {
        const role = dto.role
        return new CreateUserRequest(
            dto.name,
            dto.emailAddress,
            role !== undefined ? this.adaptUserRoleDto(role) : undefined,
            dto.password,
        )
    }

    adaptEmailMarketingConfiguration(
        em: EmailMarketingConfiguration
    ): EmailMarketingConfigurationDTO {
        return new EmailMarketingConfigurationDTO(
            em.id,
            em.isEnabled,
            this.adaptEmailMarketingSource(em.source),
            em.apiKey,
            em.serverKey,
            em.list,
            em.fields.map(field => this.adaptEmailMarketingField(field)),
            this.adaptEmailMarketingTagsList(em.tags),
            this.adaptEmailMarketingStatus(em.status)
        )
    }

    adaptMoveBookingRequest(
        booking: Booking,
        tables: Table[],
        start?: Date
    ): MoveBookingsRequestDTO {
        return new MoveBookingsRequestDTO(
            booking.id,
            tables.map(table => table.id),
            start ? this.adaptToLocalDateTime(start) : null
        )
    }

    adaptBookingAuditEntryDto(dto: BookingAuditEntryDTO): BookingAuditEntry {
        return new BookingAuditEntry(
            dto.id,
            dto.changes,
            dto.bookingId,
            dto.userId,
            dto.userName,
            dto.userEmailAddress,
            new Date(dto.dateTime)
        )
    }

    adaptOrganisationAuditEntryDto(dto: OrganisationAuditEntryDTO): OrganisationAuditEntry {
        return new OrganisationAuditEntry(
            dto.id,
            dto.changes,
            dto.organisationId,
            dto.userId,
            new Date(dto.dateTime)
        )
    }

    adaptBookingRequest(bookingRequest: BookingRequest): BookingRequestDTO {
        return new BookingRequestDTO(
            new BookingSlotDTO(this.adaptToLocalDateTime(bookingRequest.bookingSlot.dateTime)),
            this.adaptContact(bookingRequest.contact),
            bookingRequest.partySize,
            bookingRequest.notes,
            bookingRequest.agreedToMarketing,
            bookingRequest.agreedToTerms,
            bookingRequest.paymentMethodId,
            bookingRequest.reasonId,
            bookingRequest.eventId,
            bookingRequest.answers.map(answer => this.adaptAnswer(answer)),
            bookingRequest.depositPaymentIntentId,
            bookingRequest.requiresWheelchairAccess,
            bookingRequest.requiresDogFriendly,
            bookingRequest.requiresPramAccessible,
            bookingRequest.requiresHighchairFriendly,
            bookingRequest.dateCreated.toISOString()
        )
    }

    adaptBookingRequestDto(dto: BookingRequestDTO): BookingRequest {
        return new BookingRequest(
            new BookingSlot(new Date(dto.bookingSlot.dateTime)),
            this.adaptContactDto(dto.contact),
            dto.partySize,
            dto.notes,
            dto.agreedToMarketing,
            dto.agreedToTerms,
            dto.paymentMethodId,
            dto.reasonId,
            dto.eventId,
            dto.answers.map(dto => this.adaptAnswerDto(dto)),
            dto.depositPaymentIntentId,
            dto.requiresWheelchairAccess,
            dto.requiresDogFriendly,
            dto.requiresPramAccessible,
            dto.requiresHighchairFriendly,
            new Date(dto.dateCreated)
        )
    }

    adaptProductLibrary(productLibrary: ProductLibrary): ProductLibraryDTO {
        return new ProductLibraryDTO(
            productLibrary.id,
            productLibrary.venueId,
            productLibrary.consumables.map(consumable => this.adaptConsumable(consumable)),
            productLibrary.menus.map(menu => this.adaptMenu(menu)),
            productLibrary.vouchers.map(voucher => this.adaptVoucher(voucher)),
            productLibrary.modifierGroups.map(group => this.adaptModifierGroup(group))
        )
    }

    adaptProductLibraryDto(dto: ProductLibraryDTO): ProductLibrary {
        return new ProductLibrary(
            dto.id,
            dto.venueId,
            dto.consumables.map(consumable => this.adaptConsumableDto(consumable)),
            dto.menus.map(menu => this.adaptMenuDto(menu)),
            dto.vouchers.map(dto => this.adaptVoucherDto(dto)),
            dto.modifierGroups.map(group => this.adaptModifierGroupDto(group))
        )
    }

    adaptConsumable(consumable: Consumable): ConsumableDTO {
        return new ConsumableDTO(
            consumable.id,
            consumable.displayName,
            consumable.description,
            consumable.skus.map(sku => this.adaptSku(sku)),
            [...consumable.modifierGroupIds],
            this.adaptToLocalDateTime(consumable.dateCreated),
            this.adaptToLocalDateTime(consumable.dateUpdated),
            consumable.imageId
        )
    }

    adaptConsumableDto(dto: ConsumableDTO): Consumable {
        return new Consumable(
            dto.id,
            dto.displayName,
            dto.description,
            dto.skus.map(dto => this.adaptSkuDto(dto)),
            [...dto.modifierGroupIds],
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated),
            dto.imageId ?? null
        )
    }

    adaptMenu(menu: Menu): MenuDTO {
        return new MenuDTO(
            menu.id,
            menu.displayName,
            menu.description,
            this.adaptMenuLinkType(menu.linkType),
            menu.menuCourses.map(course => this.adaptMenuCourse(course)),
            this.adaptToLocalDateTime(menu.dateCreated),
            this.adaptToLocalDateTime(menu.dateUpdated),
            menu.minimumCoursesRequired,
            menu.maximumCoursesRequired,
            menu.active,
            menu.isPaid
        )
    }

    adaptMenuDto(dto: MenuDTO): Menu {
        return new Menu(
            dto.id,
            dto.displayName,
            dto.description,
            this.adaptMenuLinkTypeDto(dto.linkType),
            dto.menuCourses.map(courseDto => this.adaptMenuCourseDto(courseDto)),
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated),
            dto.minimumCoursesRequired ?? null,
            dto.maximumCoursesRequired ?? null,
            dto.active ?? true,
            dto.isPaid ?? false
        )
    }

    adaptMenuCourse(menuCourse: MenuCourse): MenuCourseDTO {
        return new MenuCourseDTO(
            menuCourse.id,
            menuCourse.menuId,
            menuCourse.displayName,
            menuCourse.orderIndex,
            menuCourse.minimumItemsRequired,
            menuCourse.maximumItemsRequired,
            menuCourse.menuItems.map(item => this.adaptMenuItem(item)),
            menuCourse.excludesFromCourseCount,
            menuCourse.description
        )
    }

    adaptMenuCourseDto(dto: MenuCourseDTO): MenuCourse {
        return new MenuCourse(
            dto.id,
            dto.menuId,
            dto.displayName,
            dto.orderIndex,
            dto.minimumItemsRequired,
            dto.maximumItemsRequired,
            dto.menuItems.map(itemDto => this.adaptMenuItemDto(itemDto)),
            dto.excludesFromCourseCount ?? false,
            dto.description ?? null
        )
    }

    adaptMenuItem(menuItem: MenuItem): MenuItemDTO {
        return new MenuItemDTO(
            menuItem.id,
            menuItem.menuId,
            menuItem.menuCourseId,
            menuItem.consumableId,
            menuItem.skuId,
            menuItem.orderIndex,
            menuItem.refundable,
            menuItem.paidOnline
        )
    }

    adaptMenuItemDto(dto: MenuItemDTO): MenuItem {
        return new MenuItem(
            dto.id,
            dto.menuId,
            dto.menuCourseId,
            dto.consumableId,
            dto.skuId,
            dto.orderIndex,
            dto.refundable ?? true,
            dto.paidOnline ?? true
        )
    }

    adaptVoucher(voucher: Voucher): VoucherDTO {
        return new VoucherDTO(
            voucher.id,
            voucher.displayName,
            voucher.description,
            voucher.imageId,
            voucher.policy,
            voucher.expiryMonths ? voucher.expiryMonths : null,
            voucher.expiryDate ? this.adaptToLocalDate(voucher.expiryDate) : null,
            voucher.postalDeliveryFee,
            voucher.skus.map(sku => this.adaptSku(sku)),
            voucher.skuValues.map(override => this.adaptVoucherSKUValue(override)),
            this.adaptToLocalDateTime(voucher.dateCreated),
            this.adaptToLocalDateTime(voucher.dateUpdated)
        )
    }

    adaptVoucherDto(dto: VoucherDTO): Voucher {
        return new Voucher(
            dto.id,
            dto.displayName,
            dto.description,
            dto.imageId,
            dto.policy,
            dto.expiryMonths ? dto.expiryMonths : null,
            dto.expiryDate ? DateTime.fromISO(dto.expiryDate, {zone: environment.assumedVenueTimeZone}).toJSDate() : null,
            dto.postalDeliveryFee ?? null,
            dto.skus.map(dto => this.adaptSkuDto(dto)),
            dto.skuValues.map(dto => this.adaptVoucherSKUValueDto(dto)),
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated)
        )
    }

    adaptVoucherSKUValue(override: VoucherSKUValue): VoucherSKUValueDTO {
        return new VoucherSKUValueDTO(
            override.id,
            override.skuId,
            override.amount,
            this.adaptToLocalDateTime(override.dateCreated),
            this.adaptToLocalDateTime(override.dateUpdated)
        )
    }

    adaptVoucherSKUValueDto(dto: VoucherSKUValueDTO): VoucherSKUValue {
        return new VoucherSKUValue(
            dto.id,
            dto.skuId,
            dto.amount,
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated)
        )
    }

    adaptSku(sku: SKU): SKUDTO {
        return new SKUDTO(
            sku.id,
            sku.price,
            sku.onSale,
            sku.dateCreated.toISOString(),
            sku.dateUpdated.toISOString()
        )
    }

    adaptSkuDto(dto: SKUDTO): SKU {
        return new SKU(
            dto.id,
            dto.price ?? null,
            dto.onSale,
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated)
        )
    }

    adaptGiftedVoucher(giftedVoucher: GiftedVoucher): GiftedVoucherDTO {
        return new GiftedVoucherDTO(
            giftedVoucher.id,
            giftedVoucher.venueId,
            giftedVoucher.lineItemId,
            giftedVoucher.shortCode,
            giftedVoucher.amount,
            giftedVoucher.currencyCode,
            giftedVoucher.redeemed,
            giftedVoucher.expiryDate ? this.adaptToLocalDate(giftedVoucher.expiryDate) : null,
            giftedVoucher.recipientName ? giftedVoucher.recipientName : null,
            giftedVoucher.postalDeliveryAddress ? this.adaptAddress(giftedVoucher.postalDeliveryAddress) : null,
            this.adaptToLocalDate(giftedVoucher.dateCreated),
            this.adaptToLocalDate(giftedVoucher.dateUpdated),
            giftedVoucher.redemptions.map(redemption => this.adaptGiftedVoucherRedemption(redemption))
        )
    }

    adaptGiftedVoucherDto(dto: GiftedVoucherDTO): GiftedVoucher {
        return new GiftedVoucher(
            dto.id,
            dto.venueId,
            dto.lineItemId,
            dto.shortCode ?? null,
            dto.amount,
            dto.currencyCode,
            dto.expiryDate
                ? DateTime.fromISO(dto.expiryDate, {zone: environment.assumedVenueTimeZone}).toJSDate()
                : null,
            dto.recipientName ? dto.recipientName : null,
            dto.postalDeliveryAddress ? this.adaptAddressDto(dto.postalDeliveryAddress) : null,
            DateTime.fromISO(dto.dateCreated, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            DateTime.fromISO(dto.dateUpdated, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            (dto.redemptions ?? []).map(redemption => this.adaptGiftedVoucherRedemptionDto(redemption))
        )
    }

    adaptGiftedVoucherRedemption(redemption: GiftedVoucherRedemption): GiftedVoucherRedemptionDTO {
        return new GiftedVoucherRedemptionDTO(
            redemption.id,
            redemption.giftedVoucherId,
            redemption.amount,
            redemption.venueId,
            redemption.venueDisplayName,
            this.adaptToLocalDateTime(redemption.dateCreated),
            redemption.dateUnredeemed ? this.adaptToLocalDateTime(redemption.dateUnredeemed) : null
        )
    }

    adaptGiftedVoucherRedemptionDto(dto: GiftedVoucherRedemptionDTO): GiftedVoucherRedemption {
        return new GiftedVoucherRedemption(
            dto.id,
            dto.giftedVoucherId,
            dto.amount,
            dto.venueId,
            dto.venueDisplayName,
            DateTime.fromISO(dto.dateCreated, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            dto.dateUnredeemed
                ? DateTime.fromISO(dto.dateUnredeemed, {zone: environment.assumedVenueTimeZone}).toJSDate()
                : null
        )
    }

    adaptGiftedVoucherAuditEntryDto(dto: GiftedVoucherAuditEntryDTO): GiftedVoucherAuditEntry {
        return new GiftedVoucherAuditEntry(
            dto.id,
            dto.changes,
            dto.giftedVoucherId,
            dto.userId ? dto.userId : null,
            new Date(dto.dateTime)
        )
    }

    private adaptPOSIntegrationSource(source: POSSource): POSSourceDTO {
        switch (source) {
            case POSSource.UNTILL:
                return POSSourceDTO.UNTILL
        }
    }

    private adaptPOSIntegrationSourceDto(dto: POSSourceDTO): POSSource {
        switch (dto) {
            case POSSourceDTO.UNTILL:
                return POSSource.UNTILL
        }
    }

    adaptPOSConfigurationDto(dto: POSConfigurationDTO): POSConfiguration {
        return new POSConfiguration(
            dto.id,
            dto.isEnabled,
            this.adaptPOSIntegrationSourceDto(dto.source),
            dto.apiBaseUrl,
            dto.databaseName,
            dto.username,
            dto.posUserId,
            dto.password,
            dto.tableMappings?.map(dto => this.adaptPOSTableMappingDto(dto)) ?? null,
            dto.onlyPushDepositBookings ?? false
        )
    }

    adaptPOSConfiguration(configuration: POSConfiguration): POSConfigurationDTO {
        return new POSConfigurationDTO(
            configuration.id,
            configuration.isEnabled,
            this.adaptPOSIntegrationSource(configuration.source),
            configuration.apiBaseUrl,
            configuration.databaseName,
            configuration.username,
            configuration.posUserId,
            configuration.password,
            configuration.tableMappings?.map(mapping => this.adaptPOSTableMapping(mapping)) ?? null,
            configuration.onlyPushDepositBookings
        )
    }

    adaptPOSTableMappingDto(dto: POSTableMappingItemDTO): POSTableMappingItem {
        return new POSTableMappingItem(
            dto.id,
            this.adaptTableDto(dto.table),
            dto.extTableRef,
        )
    }

    adaptPOSTableMapping(mapping: POSTableMappingItem): POSTableMappingItemDTO {
        return new POSTableMappingItemDTO(
            mapping.id,
            this.adaptTable(mapping.table),
            mapping.extTableRef,
        )
    }

    private adaptEmailMarketingSource(source: EmailMarketingSource): EmailMarketingSourceDTO {
        switch (source) {
            case EmailMarketingSource.EMAIL_OCTOPUS:
                return EmailMarketingSourceDTO.EMAIL_OCTOPUS
            case EmailMarketingSource.MAILCHIMP:
                return EmailMarketingSourceDTO.MAILCHIMP
        }
    }

    private adaptEmailMarketingField(field: EmailMarketingListField): EmailMarketingListFieldDTO {
        return new EmailMarketingListFieldDTO(
            this.adaptEmailMarketingListAssociationType(field.association),
            field.tag,
            field.type,
            field.label,
            field.fallback
        )
    }

    private adaptEmailMarketingListAssociationType(type: EmailMarketingListAssociationType):
        EmailMarketingListAssociationTypeDTO {
        switch (type) {
            case EmailMarketingListAssociationType.FIRSTNAME:
                return EmailMarketingListAssociationTypeDTO.FIRSTNAME
            case EmailMarketingListAssociationType.LASTNAME:
                return EmailMarketingListAssociationTypeDTO.LASTNAME
            case EmailMarketingListAssociationType.EMAIL_ADDRESS:
                return EmailMarketingListAssociationTypeDTO.EMAIL_ADDRESS
            case EmailMarketingListAssociationType.PHONE_NUMBER:
                return EmailMarketingListAssociationTypeDTO.PHONE_NUMBER
        }
    }

    private adaptEmailMarketingTagsList(tags: EmailMarketingTag[] | null):
        EmailMarketingTagDTO[] | null {
        if (tags === null) {
            return null
        }
        return tags.map(tag => this.adaptEmailMarketingTag(tag))
    }

    private adaptEmailMarketingTag(tag: EmailMarketingTag): EmailMarketingTagDTO {
        return new EmailMarketingTagDTO(
            tag.name
        )
    }

    private adaptEmailMarketingStatus(status: EmailMarketingStatus): EmailMarketingStatusDTO {
        switch (status) {
            case EmailMarketingStatus.PENDING:
                return EmailMarketingStatusDTO.PENDING
            case EmailMarketingStatus.SUBSCRIBED:
                return EmailMarketingStatusDTO.SUBSCRIBED
            case EmailMarketingStatus.UNSUBSCRIBED:
                return EmailMarketingStatusDTO.UNSUBSCRIBED
        }
    }

    adaptEmailMarketingConfigurationDto(dto: EmailMarketingConfigurationDTO):
        EmailMarketingConfiguration {
        return new EmailMarketingConfiguration(
            dto.id,
            dto.isEnabled,
            this.adaptEmailMarketingSourceDto(dto.source),
            dto.apiKey,
            dto.serverKey,
            this.adaptEmailMarketingListDto(dto.list),
            dto.fields.map(field => this.adaptEmailMarketingFieldDto(field)),
            this.adaptEmailMarketingTagsListDto(dto.tags),
            this.adaptEmailMarketingStatusDto(dto.status)
        )
    }

    adaptCustomer(customer: Customer): CustomerDTO {
        let notes: string[] = []
        if (customer.notes !== null) {
            notes = [...customer.notes]
        }
        return new CustomerDTO(
            customer.id,
            customer.firstName,
            customer.lastName,
            customer.emailAddress,
            customer.phoneNumber,
            notes,
            customer.foodDrinkPreferences,
            customer.vip,
            customer.venueId,
            [...customer.emailAddressAliases],
            customer.barred,
            customer.sendFeedbackRequest,
            customer.cardDetailsNotRequired,
            customer.depositAmount,
            customer.numberOfTimesVisited,
            customer.numberOfNoShowsAndCancellations,
            customer.latestReviewScore,
            customer.dateStatisticsUpdated?.toISOString() ?? null
        )
    }

    adaptCustomerDto(dto: CustomerDTO): Customer {
        let notes: string[] = []
        if (dto.notes !== null) {
            notes = [...dto.notes]
        }
        return new Customer(
            dto.id,
            dto.firstName,
            dto.lastName,
            dto.emailAddress,
            dto.phoneNumber,
            notes,
            dto.foodDrinkPreferences,
            dto.vip,
            dto.venueId,
            [...dto.emailAddressAliases],
            dto.barred ?? false,
            dto.sendFeedbackRequest ?? true,
            dto.cardDetailsNotRequired ?? false,
            dto.depositAmount ?? null,
            dto.numberOfTimesVisited ?? null,
            dto.numberOfNoShowsAndCancellations ?? null,
            dto.latestReviewScore ?? null,
            dto.dateStatisticsUpdated ? new Date(dto.dateStatisticsUpdated) : null
        )
    }

    adaptSenderId(senderId: SenderId): SenderIdDTO {
        return new SenderIdDTO(
            senderId.originationId,
            senderId.countryCode
        )
    }

    adaptSenderIdDto(dto: SenderIdDTO): SenderId {
        return new SenderId(
            dto.originationId,
            dto.countryCode
        )
    }

    adaptSaleDto(dto: SaleDTO): Sale {
        return new Sale(
            dto.id,
            dto.venueId,
            this.adaptOrderDto(dto.order),
            dto.payment ? this.adaptPaymentDto(dto.payment) : null,
            dto.deliveryDetails ? this.adaptDeliveryDetailsDto(dto.deliveryDetails) : null,
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated),
            dto.purpose ?? SalePurpose.VoucherPurchase
        )
    }

    adaptPaymentDto(dto: PaymentDTO): Payment {
        return new Payment(
            dto.id,
            dto.paymentIntentId,
            new Date(dto.dateCreated),
            dto.datePaid ? new Date(dto.datePaid) : null,
            dto.amount ?? null,
            (dto.refunds ?? []).map(refund => ({ ...refund, dateCreated: new Date(refund.dateCreated) })),
            dto.capturedTransactionId ?? null
        )
    }

    adaptDeliveryDetailsDto(dto: DeliveryDetailsDTO): DeliveryDetails {
        return new DeliveryDetails(
            dto.emailAddress,
            dto.name,
            dto.postalDeliveryAddress ? this.adaptAddressDto(dto.postalDeliveryAddress) : null,
        )
    }

    adaptOrderDto(dto: OrderDTO): Order {
        return new Order(
            dto.id,
            dto.venueId,
            dto.lineItems.map(lineItem => this.adaptLineItemDto(lineItem)),
            dto.currencyCode,
            dto.message,
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated),
            dto.isPaid ?? false
        )
    }

    adaptLineItemDto(dto: LineItemDTO): LineItem {
        return new LineItem(
            dto.id,
            dto.productId,
            dto.skuId,
            dto.name,
            dto.amount,
            dto.quantity,
            dto.modifiers.map(m => this.adaptLineItemModifierDto(m)),
            dto.externalReference ?? null,
            DateTime.fromISO(dto.dateCreated, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            DateTime.fromISO(dto.dateUpdated, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            dto.customerRefundableUntil ? new Date(dto.customerRefundableUntil) : null,
            dto.paidOnline ?? true
        )
    }

    private adaptLineItemModifierDto(dto: LineItemModifierDTO): LineItemModifier {
        return new LineItemModifier(
            dto.id,
            dto.productId,
            dto.skuId,
            dto.name,
            dto.amount,
            dto.quantity,
            DateTime.fromISO(dto.dateCreated, {zone: environment.assumedVenueTimeZone}).toJSDate(),
            DateTime.fromISO(dto.dateUpdated, {zone: environment.assumedVenueTimeZone}).toJSDate()
        )
    }

    private adaptModifier(modifier: Modifier): ModifierDTO {
        return new ModifierDTO(
            modifier.id,
            modifier.displayName,
            modifier.description,
            modifier.skus.map(sku => this.adaptSku(sku)),
            this.adaptToLocalDateTime(modifier.dateCreated),
            this.adaptToLocalDateTime(modifier.dateUpdated)
        )
    }

    private adaptModifierDto(dto: ModifierDTO): Modifier {
        return new Modifier(
            dto.id,
            dto.displayName,
            dto.description,
            dto.skus.map(s => this.adaptSkuDto(s)),
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated)
        )
    }

    adaptModifierGroup(group: ModifierGroup): ModifierGroupDTO {
        return new ModifierGroupDTO(
            group.id,
            group.name,
            group.minimumModifiersRequired,
            group.maximumModifiersRequired,
            group.modifiers.map(m => this.adaptModifier(m)),
            this.adaptToLocalDateTime(group.dateCreated),
            this.adaptToLocalDateTime(group.dateUpdated)
        )
    }

    adaptModifierGroupDto(dto: ModifierGroupDTO): ModifierGroup {
        return new ModifierGroup(
            dto.id,
            dto.name,
            dto.minimumModifiersRequired,
            dto.maximumModifiersRequired,
            dto.modifiers.map(m => this.adaptModifierDto(m)),
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated)
        )
    }

    adaptApiKeyViewDTO(dto: ApiKeyViewDTO): ApiKeyView {
        return new ApiKeyView(
            dto.id,
            dto.displayName,
            [...dto.permissions],
            DateTime.fromISO(dto.dateCreated, {zone: environment.assumedVenueTimeZone}).toJSDate(),
        )
    }

    private adaptEmailMarketingListDto(dto: EmailMarketingListDTO): EmailMarketingList {
        return new EmailMarketingList(
            dto.listId,
            dto.displayName
        )
    }

    private adaptEmailMarketingSourceDto(dto: EmailMarketingSourceDTO): EmailMarketingSource {
        switch (dto) {
            case EmailMarketingSourceDTO.EMAIL_OCTOPUS:
                return EmailMarketingSource.EMAIL_OCTOPUS
            case EmailMarketingSourceDTO.MAILCHIMP:
                return EmailMarketingSource.MAILCHIMP
        }
    }

    private adaptEmailMarketingFieldDto(dto: EmailMarketingListFieldDTO): EmailMarketingListField {
        return new EmailMarketingListField(
            this.adaptEmailMarketingListAssociationTypeDto(dto.association),
            dto.tag,
            dto.type,
            dto.label,
            dto.fallback
        )
    }

    private adaptEmailMarketingListAssociationTypeDto(dto: EmailMarketingListAssociationTypeDTO):
        EmailMarketingListAssociationType {
        switch (dto) {
            case EmailMarketingListAssociationTypeDTO.FIRSTNAME:
                return EmailMarketingListAssociationType.FIRSTNAME
            case EmailMarketingListAssociationTypeDTO.LASTNAME:
                return EmailMarketingListAssociationType.LASTNAME
            case EmailMarketingListAssociationTypeDTO.EMAIL_ADDRESS:
                return EmailMarketingListAssociationType.EMAIL_ADDRESS
            case EmailMarketingListAssociationTypeDTO.PHONE_NUMBER:
                return EmailMarketingListAssociationType.PHONE_NUMBER
        }
    }

    private adaptEmailMarketingTagsListDto(dto: EmailMarketingTagDTO[] | null):
        EmailMarketingTag[] | null {
        if (dto === null) {
            return null
        }
        return dto.map(dto => this.adaptEmailMarketingTagDto(dto))
    }

    private adaptEmailMarketingTagDto(dto: EmailMarketingTagDTO): EmailMarketingTag {
        return new EmailMarketingTag(
            dto.name
        )
    }

    private adaptEmailMarketingStatusDto(dto: EmailMarketingStatusDTO): EmailMarketingStatus {
        switch (dto) {
            case EmailMarketingStatusDTO.PENDING:
                return EmailMarketingStatus.PENDING
            case EmailMarketingStatusDTO.SUBSCRIBED:
                return EmailMarketingStatus.SUBSCRIBED
            case EmailMarketingStatusDTO.UNSUBSCRIBED:
                return EmailMarketingStatus.UNSUBSCRIBED
        }
    }

    private adaptEventBookingSlotLimit(limit: EventBookingSlotLimit): EventBookingSlotLimitDTO {
        return new EventBookingSlotLimitDTO(
            limit.time.toString(),
            limit.bookingLimit,
            limit.coverLimit
        )
    }

    private adaptEventBookingSlotLimitDto(dto: EventBookingSlotLimitDTO): EventBookingSlotLimit {
        return new EventBookingSlotLimit(
            new Time(dto.time, null, null),
            dto.limit,
            dto.coverLimit
        )
    }

    private adaptMenuLinkType(linkType: MenuLinkType): MenuLinkTypeDTO {
        switch (linkType) {
            case MenuLinkType.SingleOrganiser:
                return MenuLinkTypeDTO.SINGLE_ORGANISER
            case MenuLinkType.PerCover:
                return MenuLinkTypeDTO.PER_COVER
        }
    }

    private adaptMenuLinkTypeDto(dto: MenuLinkTypeDTO): MenuLinkType {
        switch (dto) {
            case MenuLinkTypeDTO.SINGLE_ORGANISER:
                return MenuLinkType.SingleOrganiser
            case MenuLinkTypeDTO.PER_COVER:
                return MenuLinkType.PerCover
        }
    }

    adaptWaitlistEntryDto(dto: WaitlistEntryDTO): WaitlistEntry {
        const date = DateTime.fromISO(dto.date, { zone: environment.assumedVenueTimeZone }).toJSDate()
        return new WaitlistEntry(
            dto.id,
            dto.organisationId,
            dto.venueId,
            dto.firstName,
            dto.lastName,
            dto.emailAddress,
            dto.phoneNumber,
            dto.merchantNotes,
            dto.partySize,
            date,
            dto.time,
            dto.reasonId,
            dto.eventId,
            dto.requiresWheelchairAccess,
            dto.requiresDogFriendly,
            dto.requiresPramAccessible,
            dto.requiresHighchairFriendly,
            new Date(dto.dateCreated),
            new Date(dto.dateUpdated),
            dto.numberOfTimesPrompted,
            dto.dateLastPrompted ? new Date(dto.dateLastPrompted) : null,
        )
    }

    adaptWaitlistEntryAuditEntryDto(dto: WaitlistEntryAuditEntryDTO): WaitlistEntryAuditEntry {
        return new WaitlistEntryAuditEntry(
            dto.id,
            dto.waitlistEntryId,
            dto.changes,
            dto.userId,
            new Date(dto.dateTime),
        )
    }
}
